// ⚠️ AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// This file is generated by openapi-typescript / RTK Query codegen
// Any manual changes will be overwritten on next generation
// Generated: 2026-10-27

import { generatedApi as api } from "../../../../redux/services/generatedApi";
export const addTagTypes = [
  "customer-accounts",
  "entities",
  "legal-entities",
  "ledger",
  "otop-requests",
  "cop-check",
  "confirmation-requirements",
  "payments",
  "blockchain-withdrawals",
  "payment-reasons",
  "ticker",
  "account",
  "pricing-engine",
  "core",
  "journal-payment",
  "journal-blockchain",
  "registration",
  "kyc",
  "customer-account-applications",
  "business-types",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSettlementMethods: build.query<
        GetSettlementMethodsApiResponse,
        GetSettlementMethodsApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-accounts/${queryArg.customerAccountId}/settlement-methods`,
        }),
        providesTags: ["customer-accounts"],
      }),
      getCustomerAccountBalances: build.query<
        GetCustomerAccountBalancesApiResponse,
        GetCustomerAccountBalancesApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-accounts/${queryArg.customerAccountId}/balances`,
        }),
        providesTags: ["customer-accounts"],
      }),
      getCustomerAccountCapabilities: build.query<
        GetCustomerAccountCapabilitiesApiResponse,
        GetCustomerAccountCapabilitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-accounts/${queryArg.customerAccountId}/capabilities`,
        }),
        providesTags: ["customer-accounts"],
      }),
      getDeliverableCountries: build.query<
        GetDeliverableCountriesApiResponse,
        GetDeliverableCountriesApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-accounts/${queryArg.customerAccountId}/deliverable-countries/${queryArg.currency}`,
        }),
        providesTags: ["customer-accounts"],
      }),
      getCustomerAccountBeneficialOwners: build.query<
        GetCustomerAccountBeneficialOwnersApiResponse,
        GetCustomerAccountBeneficialOwnersApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-accounts/${queryArg.customerAccountId}/beneficial-owners`,
        }),
        providesTags: ["customer-accounts"],
      }),
      getCountries: build.query<GetCountriesApiResponse, GetCountriesApiArg>({
        query: (queryArg) => ({
          url: `/countries`,
          params: {
            sortBy: queryArg.sortBy,
          },
        }),
        providesTags: ["entities"],
      }),
      getSelf: build.query<GetSelfApiResponse, GetSelfApiArg>({
        query: () => ({ url: `/self` }),
        providesTags: ["legal-entities"],
      }),
      getProducts: build.query<GetProductsApiResponse, GetProductsApiArg>({
        query: () => ({ url: `/products` }),
        providesTags: ["ledger"],
      }),
      getCustomerAccountStatement: build.query<
        GetCustomerAccountStatementApiResponse,
        GetCustomerAccountStatementApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-account-ledger/${queryArg.customerAccountId}/statement/${queryArg.productId}`,
          params: {
            timeFrame: queryArg.timeFrame,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
            ledgerCode: queryArg.ledgerCode,
            filter: queryArg.filter,
          },
        }),
        providesTags: ["ledger"],
      }),
      getLedgerEntries: build.query<
        GetLedgerEntriesApiResponse,
        GetLedgerEntriesApiArg
      >({
        query: (queryArg) => ({
          url: `/ledger-entries`,
          params: {
            timeFrame: queryArg.timeFrame,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
            filterProduct: queryArg.filterProduct,
            filterBankAccount: queryArg.filterBankAccount,
            filterCustomerAccount: queryArg.filterCustomerAccount,
            filterSilo: queryArg.filterSilo,
            filterLedgerCode: queryArg.filterLedgerCode,
            filterLedgerType: queryArg.filterLedgerType,
            filterBookingEntity: queryArg.filterBookingEntity,
            pageCursor: queryArg.pageCursor,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ["ledger"],
      }),
      createOtop: build.mutation<CreateOtopApiResponse, CreateOtopApiArg>({
        query: (queryArg) => ({
          url: `/otop-requests/${queryArg.resourceType}/${queryArg.resourceTypeId}`,
          method: "POST",
          body: queryArg.createOtopRequest,
        }),
        invalidatesTags: ["otop-requests"],
      }),
      verifyOtop: build.mutation<VerifyOtopApiResponse, VerifyOtopApiArg>({
        query: (queryArg) => ({
          url: `/otop-requests/${queryArg.otopRequestId}/actions/verify`,
          method: "POST",
          body: queryArg.verifyOtopRequest,
        }),
        invalidatesTags: ["otop-requests"],
      }),
      doCopCheck: build.mutation<DoCopCheckApiResponse, DoCopCheckApiArg>({
        query: (queryArg) => ({
          url: `/cop-check`,
          method: "POST",
          body: queryArg.copCheckRequest,
        }),
        invalidatesTags: ["cop-check"],
      }),
      getPaymentRequirements: build.query<
        GetPaymentRequirementsApiResponse,
        GetPaymentRequirementsApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/${queryArg.uuid}/confirmation-requirements`,
        }),
        providesTags: ["confirmation-requirements"],
      }),
      getBlockchainWithdrawalRequirements: build.query<
        GetBlockchainWithdrawalRequirementsApiResponse,
        GetBlockchainWithdrawalRequirementsApiArg
      >({
        query: (queryArg) => ({
          url: `/blockchain-withdrawals/${queryArg.uuid}/confirmation-requirements`,
        }),
        providesTags: ["confirmation-requirements"],
      }),
      confirmPaymentInstruction: build.mutation<
        ConfirmPaymentInstructionApiResponse,
        ConfirmPaymentInstructionApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/${queryArg.paymentId}/confirm-instruction`,
          method: "POST",
          body: queryArg.confirmInstructionRequest,
        }),
        invalidatesTags: ["payments"],
      }),
      cancelPaymentInstruction: build.mutation<
        CancelPaymentInstructionApiResponse,
        CancelPaymentInstructionApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/${queryArg.paymentId}/cancel-instruction`,
          method: "POST",
        }),
        invalidatesTags: ["payments"],
      }),
      confirmBlockchainWithdrawalInstruction: build.mutation<
        ConfirmBlockchainWithdrawalInstructionApiResponse,
        ConfirmBlockchainWithdrawalInstructionApiArg
      >({
        query: (queryArg) => ({
          url: `/blockchain-withdrawals/${queryArg.blockchainWithdrawalId}/confirm-instruction`,
          method: "POST",
          body: queryArg.confirmWithdrawalInstructionRequest,
        }),
        invalidatesTags: ["blockchain-withdrawals"],
      }),
      cancelBlockchainWithdrawalInstruction: build.mutation<
        CancelBlockchainWithdrawalInstructionApiResponse,
        CancelBlockchainWithdrawalInstructionApiArg
      >({
        query: (queryArg) => ({
          url: `/blockchain-withdrawals/${queryArg.blockchainWithdrawalId}/cancel-instruction`,
          method: "POST",
        }),
        invalidatesTags: ["blockchain-withdrawals"],
      }),
      getPaymentReasons: build.query<
        GetPaymentReasonsApiResponse,
        GetPaymentReasonsApiArg
      >({
        query: (queryArg) => ({
          url: `/payment-reasons/${queryArg.currency}/${queryArg.country}`,
        }),
        providesTags: ["payment-reasons"],
      }),
      getPrices: build.query<GetPricesApiResponse, GetPricesApiArg>({
        query: (queryArg) => ({ url: `/prices/${queryArg.baseProduct}` }),
        providesTags: ["ticker"],
      }),
      createBeneficiary: build.mutation<
        CreateBeneficiaryApiResponse,
        CreateBeneficiaryApiArg
      >({
        query: (queryArg) => ({
          url: `/beneficiaries`,
          method: "POST",
          body: queryArg.createBeneficiaryRequest,
        }),
        invalidatesTags: ["account"],
      }),
      getBeneficiary: build.query<
        GetBeneficiaryApiResponse,
        GetBeneficiaryApiArg
      >({
        query: (queryArg) => ({ url: `/beneficiaries/${queryArg.uuid}` }),
        providesTags: ["account"],
      }),
      updateBeneficiary: build.mutation<
        UpdateBeneficiaryApiResponse,
        UpdateBeneficiaryApiArg
      >({
        query: (queryArg) => ({
          url: `/beneficiaries/${queryArg.uuid}`,
          method: "PATCH",
          body: queryArg.updateBeneficiaryRequest,
        }),
        invalidatesTags: ["account"],
      }),
      deleteBeneficiary: build.mutation<
        DeleteBeneficiaryApiResponse,
        DeleteBeneficiaryApiArg
      >({
        query: (queryArg) => ({
          url: `/beneficiaries/${queryArg.uuid}`,
          method: "DELETE",
        }),
        invalidatesTags: ["account"],
      }),
      createPricingRequest: build.mutation<
        CreatePricingRequestApiResponse,
        CreatePricingRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing-requests`,
          method: "POST",
          body: queryArg.createPricingEngineRequest,
        }),
        invalidatesTags: ["pricing-engine"],
      }),
      getPricingRequest: build.query<
        GetPricingRequestApiResponse,
        GetPricingRequestApiArg
      >({
        query: (queryArg) => ({ url: `/pricing-requests/${queryArg.uuid}` }),
        providesTags: ["pricing-engine"],
      }),
      requotePricingRequest: build.mutation<
        RequotePricingRequestApiResponse,
        RequotePricingRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing-requests/${queryArg.uuid}/requote`,
          method: "POST",
          body: queryArg.requotePricingRequest,
        }),
        invalidatesTags: ["pricing-engine"],
      }),
      acceptPricingRequest: build.mutation<
        AcceptPricingRequestApiResponse,
        AcceptPricingRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing-requests/${queryArg.uuid}/accept`,
          method: "POST",
        }),
        invalidatesTags: ["pricing-engine"],
      }),
      getAllBeneficiaries: build.query<
        GetAllBeneficiariesApiResponse,
        GetAllBeneficiariesApiArg
      >({
        query: (queryArg) => ({
          url: `/all-beneficiaries`,
          params: {
            filterName: queryArg.filterName,
            filterCustomerAccount: queryArg.filterCustomerAccount,
            filterActive: queryArg.filterActive,
            pageCursor: queryArg.pageCursor,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ["core"],
      }),
      getUnconfirmedPayments: build.query<
        GetUnconfirmedPaymentsApiResponse,
        GetUnconfirmedPaymentsApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/unconfirmed-payments`,
          params: {
            filterCustomerAccount: queryArg.filterCustomerAccount,
            filterCurrency: queryArg.filterCurrency,
          },
        }),
        providesTags: ["core"],
      }),
      getProcessingPayments: build.query<
        GetProcessingPaymentsApiResponse,
        GetProcessingPaymentsApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/processing-payments`,
          params: {
            filterCustomerAccount: queryArg.filterCustomerAccount,
            filterCurrency: queryArg.filterCurrency,
          },
        }),
        providesTags: ["core"],
      }),
      getBeneficiaryTemplates: build.query<
        GetBeneficiaryTemplatesApiResponse,
        GetBeneficiaryTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/beneficiary-templates`,
          params: {
            filterCurrency: queryArg.filterCurrency,
            filterCountry: queryArg.filterCountry,
            filterBeneficiaryType: queryArg.filterBeneficiaryType,
          },
        }),
        providesTags: ["journal-payment"],
      }),
      getVirtualAssets: build.query<
        GetVirtualAssetsApiResponse,
        GetVirtualAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/virtual-assets`,
          params: {
            pageCursor: queryArg.pageCursor,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ["journal-blockchain"],
      }),
      getVasps: build.query<GetVaspsApiResponse, GetVaspsApiArg>({
        query: (queryArg) => ({
          url: `/vasps`,
          params: {
            pageCursor: queryArg.pageCursor,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ["journal-blockchain"],
      }),
      createBlockchainBeneficiary: build.mutation<
        CreateBlockchainBeneficiaryApiResponse,
        CreateBlockchainBeneficiaryApiArg
      >({
        query: (queryArg) => ({
          url: `/blockchain-beneficiaries`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["journal-blockchain"],
      }),
      getBlockchainBeneficiary: build.query<
        GetBlockchainBeneficiaryApiResponse,
        GetBlockchainBeneficiaryApiArg
      >({
        query: (queryArg) => ({
          url: `/blockchain-beneficiaries/${queryArg.uuid}`,
        }),
        providesTags: ["journal-blockchain"],
      }),
      updateBlockchainBeneficiary: build.mutation<
        UpdateBlockchainBeneficiaryApiResponse,
        UpdateBlockchainBeneficiaryApiArg
      >({
        query: (queryArg) => ({
          url: `/blockchain-beneficiaries/${queryArg.uuid}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["journal-blockchain"],
      }),
      deleteBlockchainBeneficiary: build.mutation<
        DeleteBlockchainBeneficiaryApiResponse,
        DeleteBlockchainBeneficiaryApiArg
      >({
        query: (queryArg) => ({
          url: `/blockchain-beneficiaries/${queryArg.uuid}`,
          method: "DELETE",
        }),
        invalidatesTags: ["journal-blockchain"],
      }),
      sendRegistrationEmailOtp: build.mutation<
        SendRegistrationEmailOtpApiResponse,
        SendRegistrationEmailOtpApiArg
      >({
        query: (queryArg) => ({
          url: `/registration/send-email-otp`,
          method: "POST",
          body: queryArg.sendEmailOtpRequest,
        }),
        invalidatesTags: ["registration"],
      }),
      verifyRegistrationEmailOtp: build.mutation<
        VerifyRegistrationEmailOtpApiResponse,
        VerifyRegistrationEmailOtpApiArg
      >({
        query: (queryArg) => ({
          url: `/registration/verify-email-otp`,
          method: "POST",
          body: queryArg.verifyEmailOtpRequest,
        }),
        invalidatesTags: ["registration"],
      }),
      sendRegistrationSmsOtp: build.mutation<
        SendRegistrationSmsOtpApiResponse,
        SendRegistrationSmsOtpApiArg
      >({
        query: (queryArg) => ({
          url: `/registration/send-sms-otp`,
          method: "POST",
          body: queryArg.sendSmsOtpRequest,
        }),
        invalidatesTags: ["registration"],
      }),
      verifyRegistrationSmsOtp: build.mutation<
        VerifyRegistrationSmsOtpApiResponse,
        VerifyRegistrationSmsOtpApiArg
      >({
        query: (queryArg) => ({
          url: `/registration/verify-sms-otp`,
          method: "POST",
          body: queryArg.verifySmsOtpRequest,
        }),
        invalidatesTags: ["registration"],
      }),
      register: build.mutation<RegisterApiResponse, RegisterApiArg>({
        query: (queryArg) => ({
          url: `/registration/register`,
          method: "POST",
          body: queryArg.registerRequest,
        }),
        invalidatesTags: ["registration"],
      }),
      getPhonePrefixes: build.query<
        GetPhonePrefixesApiResponse,
        GetPhonePrefixesApiArg
      >({
        query: () => ({ url: `/registration/phone-prefixes` }),
        providesTags: ["registration"],
      }),
      getRegistrations: build.query<
        GetRegistrationsApiResponse,
        GetRegistrationsApiArg
      >({
        query: () => ({ url: `/registrations` }),
        providesTags: ["registration"],
      }),
      createKycAccessToken: build.mutation<
        CreateKycAccessTokenApiResponse,
        CreateKycAccessTokenApiArg
      >({
        query: () => ({ url: `/kyc/access-token`, method: "POST" }),
        invalidatesTags: ["kyc"],
      }),
      getCustomerAccountApplications: build.query<
        GetCustomerAccountApplicationsApiResponse,
        GetCustomerAccountApplicationsApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-account-applications`,
          params: {
            filter: queryArg.filter,
          },
        }),
        providesTags: ["customer-account-applications"],
      }),
      createCustomerAccountApplication: build.mutation<
        CreateCustomerAccountApplicationApiResponse,
        CreateCustomerAccountApplicationApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-account-applications`,
          method: "POST",
          body: queryArg.createCustomerAccountApplicationRequest,
        }),
        invalidatesTags: ["customer-account-applications"],
      }),
      getCustomerAccountApplication: build.query<
        GetCustomerAccountApplicationApiResponse,
        GetCustomerAccountApplicationApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-account-applications/${queryArg.applicationId}`,
        }),
        providesTags: ["customer-account-applications"],
      }),
      updateCustomerAccountApplication: build.mutation<
        UpdateCustomerAccountApplicationApiResponse,
        UpdateCustomerAccountApplicationApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-account-applications/${queryArg.applicationId}`,
          method: "PATCH",
          body: queryArg.updateCustomerAccountApplicationRequest,
        }),
        invalidatesTags: ["customer-account-applications"],
      }),
      submitCustomerAccountApplication: build.mutation<
        SubmitCustomerAccountApplicationApiResponse,
        SubmitCustomerAccountApplicationApiArg
      >({
        query: (queryArg) => ({
          url: `/customer-account-applications/${queryArg.applicationId}/submit`,
          method: "POST",
        }),
        invalidatesTags: ["customer-account-applications"],
      }),
      getTransactionRanges: build.query<
        GetTransactionRangesApiResponse,
        GetTransactionRangesApiArg
      >({
        query: (queryArg) => ({
          url: `/onboarding/transaction-ranges`,
          params: {
            currency: queryArg.currency,
          },
        }),
        providesTags: ["customer-account-applications"],
      }),
      getBusinessTypes: build.query<
        GetBusinessTypesApiResponse,
        GetBusinessTypesApiArg
      >({
        query: () => ({ url: `/business-types` }),
        providesTags: ["business-types"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as api };
export type GetSettlementMethodsApiResponse =
  /** status 200 Settlement methods available for the customer account */ SettlementMethodsResponseRead;
export type GetSettlementMethodsApiArg = {
  /** UUID of the customer account */
  customerAccountId: string;
};
export type GetCustomerAccountBalancesApiResponse =
  /** status 200 Customer account balances */ BalancesResponse;
export type GetCustomerAccountBalancesApiArg = {
  /** UUID of the customer account */
  customerAccountId: string;
};
export type GetCustomerAccountCapabilitiesApiResponse =
  /** status 200 Customer account capabilities (tradable and payable products) */ CapabilitiesResponse;
export type GetCustomerAccountCapabilitiesApiArg = {
  /** UUID of the customer account */
  customerAccountId: string;
};
export type GetDeliverableCountriesApiResponse =
  /** status 200 List of countries available for payment delivery */ DeliverableCountriesResponse;
export type GetDeliverableCountriesApiArg = {
  /** UUID of the customer account */
  customerAccountId: string;
  /** Currency code (e.g., GBP, EUR, USD) - reserved for future filtering */
  currency: string;
};
export type GetCustomerAccountBeneficialOwnersApiResponse =
  /** status 200 Beneficial owners of the customer account with resolved addresses */ BeneficialOwnersResponse;
export type GetCustomerAccountBeneficialOwnersApiArg = {
  /** UUID of the customer account */
  customerAccountId: string;
};
export type GetCountriesApiResponse =
  /** status 200 List of countries with deliverable and residents flags */ CountriesResponse;
export type GetCountriesApiArg = {
  /** Sort countries by ID or NAME */
  sortBy?: CountrySortBy;
};
export type GetSelfApiResponse = /** status 200 successful operation */ Self;
export type GetSelfApiArg = void;
export type GetProductsApiResponse =
  /** status 200 successful operation */ ProductPage;
export type GetProductsApiArg = void;
export type GetCustomerAccountStatementApiResponse =
  /** status 200 successful operation */ ResolvedStatementRead;
export type GetCustomerAccountStatementApiArg = {
  /** UUID of the customer account */
  customerAccountId: string;
  /** Product identifier */
  productId: string;
  timeFrame: TimeFrame;
  startDate: string;
  endDate: string;
  /** Code of the ledger account */
  ledgerCode: number;
  filter?: {
    journal?: string[];
  };
};
export type GetLedgerEntriesApiResponse =
  /** status 200 successful operation */ ResolvedLedgerEntryPageRead;
export type GetLedgerEntriesApiArg = {
  timeFrame: TimeFrame;
  /** Start date filter */
  startDate?: string;
  /** End date filter */
  endDate?: string;
  /** Filter by product codes */
  filterProduct?: string[];
  /** Filter by bank account UUIDs */
  filterBankAccount?: string[];
  /** Filter by customer account UUIDs */
  filterCustomerAccount?: string[];
  /** Filter by silo UUIDs */
  filterSilo?: string[];
  /** Filter by ledger codes */
  filterLedgerCode?: number[];
  /** Filter by ledger types */
  filterLedgerType?: string[];
  /** Filter by booking entity codes */
  filterBookingEntity?: string[];
  /** Cursor for page-based navigation. Use endCursor from PageMetadata to get the next page. */
  pageCursor?: string;
  /** Number of items per page (1–300, default 200). */
  pageSize?: number;
};
export type CreateOtopApiResponse = /** status 201 successful operation */ {
  /** Unique id for the OTOP request */
  id: string;
  state: OtopRequestState;
  /** Number of failed verification attempts */
  failures: number;
  /** Time indicating when OTOP will expire */
  expiryTime: string;
};
export type CreateOtopApiArg = {
  /** Type of resource requiring OTOP verification */
  resourceType: OtopRequestResourceType;
  /** UUID of the resource requiring OTOP verification */
  resourceTypeId: string;
  createOtopRequest: CreateOtopRequest;
};
export type VerifyOtopApiResponse =
  /** status 200 successful operation */ OtopRequestResponse;
export type VerifyOtopApiArg = {
  /** UUID of the OTOP request to verify */
  otopRequestId: string;
  verifyOtopRequest: VerifyOtopRequest;
};
export type DoCopCheckApiResponse =
  /** status 200 successful operation */ CopCheckResponse;
export type DoCopCheckApiArg = {
  copCheckRequest: CopCheckRequest;
};
export type GetPaymentRequirementsApiResponse =
  /** status 200 successful operation */ ConfirmationRequirement;
export type GetPaymentRequirementsApiArg = {
  uuid: string;
};
export type GetBlockchainWithdrawalRequirementsApiResponse =
  /** status 200 successful operation */ {
    /** Unique identifier for the resource */
    id: string;
    /** Type of resource requiring confirmation */
    resourceType: string;
    /** Whether Strong Customer Authentication is required */
    scaRequired: boolean;
    /** Number of confirmers required */
    confirmersRequired: number;
    /** Array of confirmer objects for users who have already confirmed */
    currentConfirmers: {
      /** Unique identifier of the person who can confirm */
      id: string;
      /** First name of the confirmer */
      firstName: string;
      /** Last name of the confirmer */
      lastName: string;
    }[];
    /** Array of confirmer objects for users who are available to confirm */
    availableConfirmers: Confirmer[];
  };
export type GetBlockchainWithdrawalRequirementsApiArg = {
  uuid: string;
};
export type ConfirmPaymentInstructionApiResponse =
  /** status 200 Paginated list of payments */ {
    data: {
      id: string;
      resourceType: string;
      reference: string;
      meta: ResourceMetadataRead;
      /** Unique key of this transaction in the downstream source */
      correlationId?: string;
      paymentState: PaymentWithdrawalState;
      /** Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
       */
      currency: string;
      amount: number;
      /** UUID of the beneficiary */
      beneficiary: string;
      /** The system wide UUID of a customer account. */
      customerAccount: string;
      customerReference?: string;
      paymentDate: string;
      valueDate?: string;
      acceptableUntil?: string;
      chargeCode?: ChargeBearer;
      operationCode?: OperationCode;
      remittanceInformation?: string;
      paymentReason?: string;
      purposeCode?: string;
      ultimateBeneficiary?: string;
      /** Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
       */
      feeCurrency?: string;
      feeAmount?: number;
      instructionState: InstructionState;
      /** The system wide UUID of a person. */
      instructionOriginator?: string;
      /** The system wide UUID of a person. */
      instructionPlacer?: string;
      instructionConfirmers?: string[];
      scaMethod?: ScaMethod;
      processingState?: ProcessingState;
      /** Correlation UUID for the processing operation */
      processingId?: string;
      processedBankTransaction?: string;
      comment?: string;
    }[];
    meta?: PageMetadata;
  };
export type ConfirmPaymentInstructionApiArg = {
  /** UUID of the payment to confirm */
  paymentId: string;
  confirmInstructionRequest: ConfirmInstructionRequest;
};
export type CancelPaymentInstructionApiResponse =
  /** status 200 Paginated list of payments */ PaymentStrippedPageRead;
export type CancelPaymentInstructionApiArg = {
  /** UUID of the payment to cancel */
  paymentId: string;
};
export type ConfirmBlockchainWithdrawalInstructionApiResponse =
  /** status 200 successful operation */ {
    /** Journal UUID of a blockchain withdrawal */
    id: string;
    resourceType: string;
    reference: string;
    /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state.
     */
    meta: {
      /** Time and date this resource was created. */
      createTime?: string;
      /** The system wide UUID of a person. */
      createUser?: string;
      /** Time and date this resource was last updated. */
      updateTime?: string;
      /** The system wide UUID of a person. */
      updateUser?: string;
      /** Describes reason for the update. */
      updateComment?: string;
      /** Zero based count of updates. */
      version?: number;
      state?: ActiveInactiveDeleted;
    };
    withdrawalState: PaymentWithdrawalState;
    /** UUID of a withdrawal beneficiary entity */
    beneficiary: string;
    amount: number;
    customerReference?: string;
    withdrawalDate: string;
    valueDate?: string;
    acceptableUntil?: string;
    fee?: {
      product?: string;
      amount?: number;
    };
    instructionState: InstructionState;
    /** The system wide UUID of a person. */
    instructionOriginator?: string;
    /** The system wide UUID of a person. */
    instructionPlacer?: string;
    instructionConfirmers?: string[];
    scaMethod?: ScaMethod;
    processingId?: string;
    comment?: string;
  };
export type ConfirmBlockchainWithdrawalInstructionApiArg = {
  /** UUID of the blockchain withdrawal to confirm */
  blockchainWithdrawalId: string;
  confirmWithdrawalInstructionRequest: ConfirmWithdrawalInstructionRequest;
};
export type CancelBlockchainWithdrawalInstructionApiResponse =
  /** status 200 successful operation */ BlockchainWithdrawalStrippedRead;
export type CancelBlockchainWithdrawalInstructionApiArg = {
  /** UUID of the blockchain withdrawal to cancel */
  blockchainWithdrawalId: string;
};
export type GetPaymentReasonsApiResponse =
  /** status 200 List of payment reasons */ PaymentReason[];
export type GetPaymentReasonsApiArg = {
  /** Currency code (e.g., GBP, USD) - reserved for future use */
  currency: string;
  /** Country code (e.g., GB, US) - reserved for future use */
  country: string;
};
export type GetPricesApiResponse =
  /** status 200 successful operation */ FilteredTickerPricePage;
export type GetPricesApiArg = {
  /** Base product symbol (e.g., GBP, USD, EUR) */
  baseProduct: string;
};
export type CreateBeneficiaryApiResponse =
  /** status 201 Mutation completed successfully */ IdOnlyResponse;
export type CreateBeneficiaryApiArg = {
  createBeneficiaryRequest: CreateBeneficiaryRequest;
};
export type GetBeneficiaryApiResponse =
  /** status 200 successful operation */ FilteredBeneficiaryDetail;
export type GetBeneficiaryApiArg = {
  uuid: string;
};
export type UpdateBeneficiaryApiResponse =
  /** status 200 Mutation completed successfully */ {
    id: string;
  };
export type UpdateBeneficiaryApiArg = {
  uuid: string;
  updateBeneficiaryRequest: UpdateBeneficiaryRequest;
};
export type DeleteBeneficiaryApiResponse =
  /** status 200 Mutation completed successfully */ {
    id: string;
  };
export type DeleteBeneficiaryApiArg = {
  uuid: string;
};
export type CreatePricingRequestApiResponse =
  /** status 201 Pricing request with filtered swap instructions */ FilteredPricingEngineRequestRead;
export type CreatePricingRequestApiArg = {
  createPricingEngineRequest: CreatePricingEngineRequest;
};
export type GetPricingRequestApiResponse =
  /** status 200 Pricing request with filtered swap instructions */ {
    /** Pricing request UUID */
    id: string;
    /** Resource type */
    resourceType?: string;
    state: PricingQuoteState;
    indicativeStateReason?: PricingAlert;
    /** Time to live */
    timeToLive?: number;
    meta?: ResourceMetadataRead;
    /** The system wide UUID of a customer account. */
    customerAccount: string;
    /** The system wide UUID of a customer subaccount. */
    customerSubaccount?: string;
    /** The system wide UUID of a person. */
    originator: string;
    /** The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC), */
    silo: string;
    /** Booking entity code */
    bookingEntity?: string;
    /** Comment */
    comment?: string;
  } & {
    /** Filtered swap instructions */
    instructions: (SwapInstructionBaseRead & {
      /** Pay fee */
      payFee?: number;
      /** Receive fee */
      receiveFee?: number;
      /** Instruction state */
      state?: string;
      /** Indicative state reason */
      indicativeStateReason?: string;
      /** Settlement time */
      settlementTime?: string;
      /** Resolved transaction object or transaction UUID string */
      transaction?:
        | {
            id?: string;
            resourceType?: string;
            state?: string;
          }
        | string;
    })[];
  };
export type GetPricingRequestApiArg = {
  uuid: string;
};
export type RequotePricingRequestApiResponse =
  /** status 200 Pricing request with filtered swap instructions */ {
    /** Pricing request UUID */
    id: string;
    /** Resource type */
    resourceType?: string;
    state: PricingQuoteState;
    indicativeStateReason?: PricingAlert;
    /** Time to live */
    timeToLive?: number;
    meta?: ResourceMetadataRead;
    /** The system wide UUID of a customer account. */
    customerAccount: string;
    /** The system wide UUID of a customer subaccount. */
    customerSubaccount?: string;
    /** The system wide UUID of a person. */
    originator: string;
    /** The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC), */
    silo: string;
    /** Booking entity code */
    bookingEntity?: string;
    /** Comment */
    comment?: string;
  } & {
    /** Filtered swap instructions */
    instructions: (SwapInstructionBaseRead & {
      /** Pay fee */
      payFee?: number;
      /** Receive fee */
      receiveFee?: number;
      /** Instruction state */
      state?: string;
      /** Indicative state reason */
      indicativeStateReason?: string;
      /** Settlement time */
      settlementTime?: string;
      /** Resolved transaction object or transaction UUID string */
      transaction?:
        | {
            id?: string;
            resourceType?: string;
            state?: string;
          }
        | string;
    })[];
  };
export type RequotePricingRequestApiArg = {
  uuid: string;
  requotePricingRequest: RequotePricingRequest;
};
export type AcceptPricingRequestApiResponse =
  /** status 200 Pricing request with filtered swap instructions */ {
    /** Pricing request UUID */
    id: string;
    /** Resource type */
    resourceType?: string;
    state: PricingQuoteState;
    indicativeStateReason?: PricingAlert;
    /** Time to live */
    timeToLive?: number;
    meta?: ResourceMetadataRead;
    /** The system wide UUID of a customer account. */
    customerAccount: string;
    /** The system wide UUID of a customer subaccount. */
    customerSubaccount?: string;
    /** The system wide UUID of a person. */
    originator: string;
    /** The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC), */
    silo: string;
    /** Booking entity code */
    bookingEntity?: string;
    /** Comment */
    comment?: string;
  } & {
    /** Filtered swap instructions */
    instructions: (SwapInstructionBaseRead & {
      /** Pay fee */
      payFee?: number;
      /** Receive fee */
      receiveFee?: number;
      /** Instruction state */
      state?: string;
      /** Indicative state reason */
      indicativeStateReason?: string;
      /** Settlement time */
      settlementTime?: string;
      /** Resolved transaction object or transaction UUID string */
      transaction?:
        | {
            id?: string;
            resourceType?: string;
            state?: string;
          }
        | string;
    })[];
  };
export type AcceptPricingRequestApiArg = {
  uuid: string;
};
export type GetAllBeneficiariesApiResponse =
  /** status 200 Combined sorted list of fiat and blockchain beneficiaries */ {
    id?: string;
    /** Either 'beneficiaries' or 'blockchain-beneficiaries' */
    resourceType?: string;
    nickname?: string;
  }[];
export type GetAllBeneficiariesApiArg = {
  /** Filter by beneficiary name */
  filterName?: string;
  /** Filter by customer account UUIDs */
  filterCustomerAccount?: string[];
  /** Filter by active status */
  filterActive?: boolean;
  /** Cursor for page-based navigation. Use endCursor from PageMetadata to get the next page. */
  pageCursor?: string;
  /** Number of items per page (1–300, default 200). */
  pageSize?: number;
};
export type GetUnconfirmedPaymentsApiResponse =
  /** status 200 Combined payments and blockchain withdrawals */ {
    payments?: {
      id: string;
      resourceType: string;
      reference: string;
      meta: ResourceMetadataRead;
      currency: string;
      amount: number;
      /** Fiat beneficiary trimmed to fields displayed in UI */
      beneficiary: {
        name?: string;
        nickname?: string;
        beneficiaryType?: LegalEntityType;
        resourceType?: string;
        /** Bank account trimmed to fields displayed in ledger UI */
        bankAccount?: {
          accountName?: string;
          accountNumber?: string;
          nationalClearingCode?: string;
          iban?: string;
          bic?: string;
          country?: string;
        };
      };
      paymentDate: string;
      valueDate?: string;
      paymentState: PaymentWithdrawalState;
      instructionState: InstructionState;
      scaMethod?: ScaMethod;
      processingState?: ProcessingState;
      remittanceInformation?: string;
      /** Free-form reason/description for the payment (e.g., "Q3 invoice settlement"). */
      paymentReason?: string;
      /** Coded purpose classification (e.g., "goods_sold"). Translated via PaymentReason dictionary on the frontend. */
      purposeCode?: string;
      feeAmount?: number;
      feeCurrency?: string;
    }[];
    withdrawals?: {
      id: string;
      resourceType: string;
      reference: string;
      meta: ResourceMetadataRead;
      amount: number;
      /** Blockchain beneficiary trimmed to fields displayed in payment list and detail views */
      beneficiary: {
        /** Legal entity trimmed to display-name fields only */
        legalEntity?: {
          type?: LegalEntityType;
          firstName?: string;
          lastName?: string;
          companyName?: string;
        };
        nickname?: string;
        resourceType?: string;
        wallet?: FilteredBlockchainWallet;
        /** Virtual asset trimmed to ledgerProduct only (for currency display) */
        asset?: {
          ledgerProduct?: string;
        };
      };
      withdrawalDate: string;
      valueDate?: string;
      withdrawalState: PaymentWithdrawalState;
      instructionState: InstructionState;
      scaMethod?: ScaMethod;
      processingState?: ProcessingState;
      /** Withdrawal fee with amount and product */
      fee?: {
        amount?: number;
        product?: string;
      };
    }[];
  };
export type GetUnconfirmedPaymentsApiArg = {
  /** Filter by customer account UUIDs */
  filterCustomerAccount?: string[];
  /** Filter by currency codes (e.g. GBP, EUR, BTC) */
  filterCurrency?: string[];
};
export type GetProcessingPaymentsApiResponse =
  /** status 200 Combined payments and blockchain withdrawals */ {
    payments?: FilteredPaymentForListRead[];
    withdrawals?: FilteredBlockchainWithdrawalForListRead[];
  };
export type GetProcessingPaymentsApiArg = {
  /** Filter by customer account UUIDs */
  filterCustomerAccount?: string[];
  /** Filter by currency codes (e.g. GBP, EUR, BTC) */
  filterCurrency?: string[];
};
export type GetBeneficiaryTemplatesApiResponse =
  /** status 200 Page of beneficiary templates */ BeneficiaryTemplatePage;
export type GetBeneficiaryTemplatesApiArg = {
  /** Filter by currency codes */
  filterCurrency?: string[];
  /** Filter by country codes */
  filterCountry?: string[];
  /** Filter by beneficiary type */
  filterBeneficiaryType?: string[];
};
export type GetVirtualAssetsApiResponse =
  /** status 200 Page of filtered virtual assets */ FilteredVirtualAssetPage;
export type GetVirtualAssetsApiArg = {
  /** Cursor for page-based navigation. Use endCursor from PageMetadata to get the next page. */
  pageCursor?: string;
  /** Number of items per page (1–300, default 200). */
  pageSize?: number;
};
export type GetVaspsApiResponse =
  /** status 200 Page of filtered VASPs */ FilteredVaspInfoPage;
export type GetVaspsApiArg = {
  /** Cursor for page-based navigation. Use endCursor from PageMetadata to get the next page. */
  pageCursor?: string;
  /** Number of items per page (1–300, default 200). */
  pageSize?: number;
};
export type CreateBlockchainBeneficiaryApiResponse =
  /** status 201 Mutation completed successfully */ {
    id: string;
  };
export type CreateBlockchainBeneficiaryApiArg = {
  body: {
    customerAccount: string;
    asset: string;
    address: string;
    customerReference?: string;
    nickname?: string;
    walletType?: WalletType;
    vasp?: string;
    vaspDetails?: string;
    /** Legal entity information for a blockchain beneficiary (person or corporation) */
    legalEntity?: {
      type: LegalEntityType;
      firstName?: string;
      lastName?: string;
      companyName?: string;
      department?: string;
      subDepartment?: string;
      streetName?: string;
      buildingNumber?: string;
      buildingName?: string;
      floor?: string;
      postBox?: string;
      room?: string;
      postCode?: string;
      townName: string;
      townLocationName?: string;
      districtName?: string;
      countrySubDivision?: string;
      addressLine?: string[];
      /** ISO 3166-1 Alpha-2 country code */
      country: string;
    };
    active?: boolean;
    comment?: string;
  };
};
export type GetBlockchainBeneficiaryApiResponse =
  /** status 200 Single filtered resolved blockchain beneficiary */ FilteredResolvedBlockchainBeneficiary;
export type GetBlockchainBeneficiaryApiArg = {
  uuid: string;
};
export type UpdateBlockchainBeneficiaryApiResponse =
  /** status 200 Mutation completed successfully */ {
    id: string;
  };
export type UpdateBlockchainBeneficiaryApiArg = {
  uuid: string;
  body: {
    customerReference?: string;
    nickname?: string;
    vasp?: string;
    /** Legal entity information for a blockchain beneficiary (person or corporation) */
    legalEntity?: {
      type: LegalEntityType;
      firstName?: string;
      lastName?: string;
      companyName?: string;
      department?: string;
      subDepartment?: string;
      streetName?: string;
      buildingNumber?: string;
      buildingName?: string;
      floor?: string;
      postBox?: string;
      room?: string;
      postCode?: string;
      townName: string;
      townLocationName?: string;
      districtName?: string;
      countrySubDivision?: string;
      addressLine?: string[];
      /** ISO 3166-1 Alpha-2 country code */
      country: string;
    };
    active?: boolean;
    comment?: string;
  };
};
export type DeleteBlockchainBeneficiaryApiResponse =
  /** status 200 Mutation completed successfully */ {
    id: string;
  };
export type DeleteBlockchainBeneficiaryApiArg = {
  uuid: string;
};
export type SendRegistrationEmailOtpApiResponse =
  /** status 200 OTP sent successfully */ {
    message?: string;
    expiresIn?: number;
  };
export type SendRegistrationEmailOtpApiArg = {
  sendEmailOtpRequest: SendEmailOtpRequest;
};
export type VerifyRegistrationEmailOtpApiResponse =
  /** status 200 OTP verified successfully */ {
    verificationToken?: string;
  };
export type VerifyRegistrationEmailOtpApiArg = {
  verifyEmailOtpRequest: VerifyEmailOtpRequest;
};
export type SendRegistrationSmsOtpApiResponse =
  /** status 200 OTP sent successfully */ SendOtpResponse;
export type SendRegistrationSmsOtpApiArg = {
  sendSmsOtpRequest: SendSmsOtpRequest;
};
export type VerifyRegistrationSmsOtpApiResponse =
  /** status 200 OTP verified successfully */ VerifyOtpResponse;
export type VerifyRegistrationSmsOtpApiArg = {
  verifySmsOtpRequest: VerifySmsOtpRequest;
};
export type RegisterApiResponse =
  /** status 200 Registration successful */ RegisterResponse;
export type RegisterApiArg = {
  registerRequest: RegisterRequest;
};
export type GetPhonePrefixesApiResponse =
  /** status 200 List of phone prefixes */ PhonePrefix[];
export type GetPhonePrefixesApiArg = void;
export type GetRegistrationsApiResponse =
  /** status 200 List of registrations */ RegistrationPage;
export type GetRegistrationsApiArg = void;
export type CreateKycAccessTokenApiResponse =
  /** status 200 SumSub WebSDK access token */ KycAccessTokenResponse;
export type CreateKycAccessTokenApiArg = void;
export type GetCustomerAccountApplicationsApiResponse =
  /** status 200 List of customer account applications */ CustomerAccountApplicationPage;
export type GetCustomerAccountApplicationsApiArg = {
  filter?: {
    applicationState?: ApplicationState[];
  };
};
export type CreateCustomerAccountApplicationApiResponse =
  /** status 201 Customer account application */ CustomerAccountApplication;
export type CreateCustomerAccountApplicationApiArg = {
  createCustomerAccountApplicationRequest: CreateCustomerAccountApplicationRequest;
};
export type GetCustomerAccountApplicationApiResponse =
  /** status 200 Customer account application */ {
    id?: string;
    applicationType?: ApplicationType;
    applicationState?: ApplicationState;
    requiresDigitalAssets?: boolean;
    silo?: string;
    formData?: ApplicationFormData;
    createdAt?: string;
    updatedAt?: string;
  };
export type GetCustomerAccountApplicationApiArg = {
  applicationId: string;
};
export type UpdateCustomerAccountApplicationApiResponse =
  /** status 200 Customer account application */ {
    id?: string;
    applicationType?: ApplicationType;
    applicationState?: ApplicationState;
    requiresDigitalAssets?: boolean;
    silo?: string;
    formData?: ApplicationFormData;
    createdAt?: string;
    updatedAt?: string;
  };
export type UpdateCustomerAccountApplicationApiArg = {
  applicationId: string;
  updateCustomerAccountApplicationRequest: UpdateCustomerAccountApplicationRequest;
};
export type SubmitCustomerAccountApplicationApiResponse =
  /** status 200 Customer account application */ {
    id?: string;
    applicationType?: ApplicationType;
    applicationState?: ApplicationState;
    requiresDigitalAssets?: boolean;
    silo?: string;
    formData?: ApplicationFormData;
    createdAt?: string;
    updatedAt?: string;
  };
export type SubmitCustomerAccountApplicationApiArg = {
  applicationId: string;
};
export type GetTransactionRangesApiResponse =
  /** status 200 Transaction value ranges for onboarding */ TransactionRanges;
export type GetTransactionRangesApiArg = {
  currency: string;
};
export type GetBusinessTypesApiResponse =
  /** status 200 List of non-prohibited business types */ FilteredBusinessTypePage;
export type GetBusinessTypesApiArg = void;
export type ResourceMetadata = {
  /** Time and date this resource was created. */
  createTime?: string;
  /** The system wide UUID of a person. */
  createUser?: string;
  /** Time and date this resource was last updated. */
  updateTime?: string;
  /** The system wide UUID of a person. */
  updateUser?: string;
  /** Describes reason for the update. */
  updateComment?: string;
  /** Zero based count of updates. */
  version?: number;
  state?: ActiveInactiveDeleted;
};
export type ResourceMetadataRead = {
  /** Time and date this resource was created. */
  createTime?: string;
  /** The system wide UUID of a person. */
  createUser?: string;
  /** Time and date this resource was last updated. */
  updateTime?: string;
  /** The system wide UUID of a person. */
  updateUser?: string;
  /** Describes reason for the update. */
  updateComment?: string;
  /** Zero based count of updates. */
  version?: number;
  state?: ActiveInactiveDeleted;
};
export type BankAccountSummary = {
  id: string;
  resourceType?: string;
  accountName: string;
  accountType?: string;
  accountNameConfirmation?: string;
  accountNumber?: string;
  nationalClearingCode?: string;
  nationalClearingCodeType?: string;
  nationalBankCode?: string;
  nationalBranchCode?: string;
  iban?: string;
  bic?: string;
  country: string;
  nickname?: string;
  meta?: ResourceMetadata;
};
export type BankAccountSummaryRead = {
  id: string;
  resourceType?: string;
  accountName: string;
  accountType?: string;
  accountNameConfirmation?: string;
  accountNumber?: string;
  nationalClearingCode?: string;
  nationalClearingCodeType?: string;
  nationalBankCode?: string;
  nationalBranchCode?: string;
  iban?: string;
  bic?: string;
  country: string;
  nickname?: string;
  meta?: ResourceMetadataRead;
};
export type PaymentRail = {
  /** Payment processor ID (raw code, e.g. "FP", "SWIFT", "SCTINST") */
  id: string;
  /** Human-readable name (e.g. "Faster Payments", "SWIFT", "SEPA Instant") */
  name: string;
};
export type FiatSettlementMethod = {
  /** Settlement instruction ID */
  id: string;
  /** Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
   */
  currency: string;
  bankAccount: BankAccountSummary;
  /** Available payment rails resolved from PaymentProcessor on the BFF. Each entry contains the raw processor ID and human-readable name. The frontend uses the `id` field to check for specific rails (e.g. SWIFT).
   */
  rails: PaymentRail[];
  /** Payment reference that must be included in the bank transfer */
  reference?: string;
};
export type FiatSettlementMethodRead = {
  /** Settlement instruction ID */
  id: string;
  /** Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
   */
  currency: string;
  bankAccount: BankAccountSummaryRead;
  /** Available payment rails resolved from PaymentProcessor on the BFF. Each entry contains the raw processor ID and human-readable name. The frontend uses the `id` field to check for specific rails (e.g. SWIFT).
   */
  rails: PaymentRail[];
  /** Payment reference that must be included in the bank transfer */
  reference?: string;
};
export type NetworkInfo = {
  /** Blockchain chain-id (CAIP-2 format) */
  id: string;
  /** Human-readable blockchain name */
  name: string;
  /** Blockchain namespace (e.g., eip155, bip122) */
  namespace: string;
};
export type BlockchainSettlementMethod = {
  /** Settlement instruction ID */
  id: string;
  /** Virtual asset ID for this settlement method */
  virtualAssetId: string;
  /** Product code (e.g., USDC, USDT, BTC) */
  product: string;
  /** Blockchain network name */
  network: string;
  /** Blockchain network code */
  networkCode: string;
  /** Wallet address */
  address: string;
  /** Optional nickname for the wallet */
  nickname?: string;
  /** Networks this customer can settle this product on, derived from their own settlement instructions — not every network where the asset exists in the catalogue */
  availableNetworks: NetworkInfo[];
};
export type SettlementMethodsResponse = {
  /** Fiat settlement methods (bank accounts) */
  fiat: FiatSettlementMethod[];
  /** Blockchain settlement methods (wallets) */
  blockchain: BlockchainSettlementMethod[];
};
export type SettlementMethodsResponseRead = {
  /** Fiat settlement methods (bank accounts) */
  fiat: FiatSettlementMethodRead[];
  /** Blockchain settlement methods (wallets) */
  blockchain: BlockchainSettlementMethod[];
};
export type ExceptionDetail = {
  status: number;
  error?: string;
  /** Human readable description of the type of exception. */
  message?: string;
  /** Human readable description of the exception instance. */
  messages?: string[];
  /** The name of the service that was the original source or cause of events, commands, or exceptions. */
  origin: string;
  /** Type of the exception unique to the originating service. Imparts no
    information for a particular exception instance. Intended to be used with
    the parameters property for localisation of the exception message.
     */
  type: string;
  /** Correlation id for the request. This is the OpenTelemetry span id. */
  spanId?: string;
  parameters?: {
    [key: string]: string;
  };
};
export type ProductBalance = {
  /** Current balance amount */
  balance: number;
  /** Number of decimal places for the product */
  decimalPlaces: number;
  /** Last transaction date. May be omitted if no transactions have occurred for this product. */
  lastDate?: string;
};
export type BalancesResponse = {
  /** Map of product code to balance information */
  balances: {
    [key: string]: ProductBalance;
  };
};
export type OnlineQuotation = {
  state: OnlineQuotationFlag;
  /** Start time for trading (local-time) */
  startTime: string;
  /** End time for trading (local-time) */
  endTime: string;
  /** Buy limit for trading */
  buyLimit: number;
  /** Sell limit for trading */
  sellLimit: number;
};
export type TradableProduct = {
  /** Product code */
  id: string;
  resourceType: ProductType;
  /** Whether trading is currently enabled via self-service */
  isTradable: boolean;
  tradingRestriction?: OnlineTradingMode;
  onlineQuotation?: OnlineQuotation;
};
export type PayableProduct = {
  /** Product code */
  id: string;
  resourceType: ProductType;
};
export type CapabilitiesResponse = {
  /** Products that can be traded */
  tradable: TradableProduct[];
  /** Products that can be used for payments */
  payable: PayableProduct[];
};
export type DeliverableCountry = {
  /** ISO 3166-1 Alpha-2 country code */
  id: string;
  /** Country name */
  name?: string;
};
export type DeliverableCountriesResponse = {
  /** List of countries available for payment delivery */
  data: DeliverableCountry[];
};
export type BeneficialOwnerAddress = {
  line1?: string;
  line2?: string;
  line3?: string;
  postTown?: string;
  postCode?: string;
  state?: string;
  country?: string;
};
export type BeneficialOwnerPerson = {
  id: string;
  firstName: string;
  lastName: string;
  address?: BeneficialOwnerAddress;
};
export type BeneficialOwnerCorporation = {
  id: string;
  name: string;
  /** ISO 3166-1 Alpha-2 country code */
  incorporationCountry: string;
  address?: BeneficialOwnerAddress;
};
export type BeneficialOwnersResponse = {
  /** Beneficial owners that are natural persons */
  people: BeneficialOwnerPerson[];
  /** Beneficial owners that are corporate entities */
  corporations: BeneficialOwnerCorporation[];
};
export type Country = {
  /** ISO 3166-1 Alpha-2 country code */
  id: string;
  /** Country name */
  name?: string;
  /** ISO 3166-1 Alpha-3 country code */
  alpha3Code?: string;
  /** ISO 3166-1 numeric code */
  numericCode?: number;
  /** Whether the country is in the Eurozone */
  eurozone?: boolean;
  /** Whether the country supports SEPA payments */
  sepa?: boolean;
  /** Whether payments can be delivered to this country (has payment profile and not banned) */
  deliverable: boolean;
  /** Whether residents of this country are allowed (not banned) */
  residents: boolean;
};
export type CountriesResponse = {
  /** List of countries */
  data: Country[];
};
export type Address = {
  line1?: string;
  line2?: string;
  line3?: string;
  city?: string;
  postTown?: string;
  postCode?: string;
  state?: string;
  country?: string;
};
export type CustomerAccountProfileSummary = {
  baseCurrency?: string;
};
export type CustomerAccountDetail = {
  id?: string;
  resourceType?: string;
  name?: string;
  /** External reference identifier */
  reference?: string;
  accountType?: AccountType;
  accountState?: AccountState;
  bookingEntityCodes?: string[];
  profile?: CustomerAccountProfileSummary;
  /** Resolved legal entity (person or corporation) that owns this account */
  resolvedLegalEntity?: {
    resourceType?: string;
    firstName?: string;
    lastName?: string;
    companyName?: string;
    addresses?: {
      [key: string]: Address;
    };
  };
};
export type CustomerAccountUser = {
  id?: string;
  resourceType?: string;
  reference?: string;
  customerAccount?: CustomerAccountDetail;
  relationship?: AccountRole;
  role?: AccountRole;
  trader?: boolean;
  confirmer?: boolean;
  riskAssessmentState?: ComplianceCheckState;
  termsAccepted?: ComplianceCheckState;
  emailAddress?: string;
  comment?: string;
};
export type Self = {
  id: string;
  resourceType: string;
  firstName: string;
  lastName: string;
  title?: string;
  middleNames?: string;
  dateOfBirth?: string;
  mobilePhone?: string;
  email?: string;
  addresses?: {
    [key: string]: Address;
  };
  customerAccounts: CustomerAccountUser[];
};
export type ProductBase = {
  resourceType: string;
  name: string;
  description?: string;
  decimalPlaces: number;
};
export type Product = {
  /** Id of a product entity managed by the `@jftechnology/ledger` service
   */
  code: string;
} & ProductBase;
export type PageMetadata = {
  /** Pagination support. Presence indicates that there are items falling above this cursor in the data collection. This property can be used as the 'page[cursor]' parameter in subsequent searches with a negative 'page[size]' query parameter to  obtain the previous page.
   */
  startCursor?: string;
  /** Pagination support. Presence indicates that there are items falling below this cursor in the data collection. This property can be used as the 'page[cursor]' parameter in subsequent searches with a positive 'page[size]' query parameter to  obtain the next page.
   */
  endCursor?: string;
};
export type ProductPage = {
  data: Product[];
  meta?: PageMetadata;
};
export type LedgerEntry = {
  /** Source journal indicator */
  journal: string;
  /** ID of source journal entry */
  uuid: string;
  /** Index of ledger entry for the journal entry */
  item: number;
  /** Code of a `ledger-account` entity managed by the `@jftechnology/ledger` service.
   */
  ledgerCode: number;
  /** Id of a product entity managed by the `@jftechnology/ledger` service
   */
  product: string;
  /** The resource type of the product as defined in its respective `Product.resourceType` property. */
  productType: string;
  /** Non-negative amount of the related product */
  credit: number;
  /** Non-negative amount of the related product */
  debit: number;
  bookDate: string;
  valueDate: string;
  /** The id of a booking entity */
  bookingEntity?: string;
  /** UUID of a bank account entity managed by the `@jftechnology/journal-payment` service. */
  bankAccount?: string;
  /** The system wide UUID of a customer account. */
  customerAccount?: string;
  /** The system wide UUID of a customer subaccount. */
  customerSubaccount?: string;
  /** The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC), */
  silo?: string;
  /** Running balance */
  balance?: number;
  reason?: string;
  comment?: string;
};
export type FilteredBeneficiaryBankAccount = {
  accountName?: string;
  accountNumber?: string;
  nationalClearingCode?: string;
  iban?: string;
  bic?: string;
  country?: string;
};
export type FilteredFiatBeneficiary = {
  name?: string;
  nickname?: string;
  beneficiaryType?: LegalEntityType;
  resourceType?: string;
  bankAccount?: FilteredBeneficiaryBankAccount;
};
export type FilteredResolvedPaymentData = {
  beneficiary?: FilteredFiatBeneficiary | string;
  feeAmount?: number;
  feeCurrency?: string;
  paymentState?: PaymentWithdrawalState;
  remittanceInformation?: string;
  /** Free-form reason/description for the payment (e.g., "Q3 invoice settlement"). */
  paymentReason?: string;
  /** Coded purpose classification (e.g., "goods_sold"). Translated via PaymentReason dictionary on the frontend. */
  purposeCode?: string;
  meta?: ResourceMetadata;
  reference?: string;
  valueDate?: string;
  instructionState?: InstructionState;
};
export type FilteredResolvedPaymentDataRead = {
  beneficiary?: FilteredFiatBeneficiary | string;
  feeAmount?: number;
  feeCurrency?: string;
  paymentState?: PaymentWithdrawalState;
  remittanceInformation?: string;
  /** Free-form reason/description for the payment (e.g., "Q3 invoice settlement"). */
  paymentReason?: string;
  /** Coded purpose classification (e.g., "goods_sold"). Translated via PaymentReason dictionary on the frontend. */
  purposeCode?: string;
  meta?: ResourceMetadataRead;
  reference?: string;
  valueDate?: string;
  instructionState?: InstructionState;
};
export type FilteredDebitBankAccount = {
  accountName?: string;
};
export type FilteredRelatedPayment = {
  beneficiary?: FilteredFiatBeneficiary | string;
  remittanceInformation?: string;
  feeAmount?: number;
  feeCurrency?: string;
  /** Free-form reason/description for the related payment. */
  paymentReason?: string;
  /** Coded purpose classification for the related payment. Translated via PaymentReason dictionary on the frontend. */
  purposeCode?: string;
};
export type FilteredResolvedBankTransaction = {
  transactionState?: BankTransactionState;
  transactionTime?: string;
  narrative?: string[];
  reference?: string;
  meta?: ResourceMetadata;
  valueDate?: string;
  debitBankAccount?: FilteredDebitBankAccount;
  resolvedRelatedPayment?: FilteredRelatedPayment;
};
export type FilteredResolvedBankTransactionRead = {
  transactionState?: BankTransactionState;
  transactionTime?: string;
  narrative?: string[];
  reference?: string;
  meta?: ResourceMetadataRead;
  valueDate?: string;
  debitBankAccount?: FilteredDebitBankAccount;
  resolvedRelatedPayment?: FilteredRelatedPayment;
};
export type FilteredLegalEntity = {
  type?: LegalEntityType;
  firstName?: string;
  lastName?: string;
  companyName?: string;
};
export type FilteredBlockchainExplorer = {
  addressUrl?: string;
  transactionUrl?: string;
};
export type FilteredBlockchainNetwork = {
  id?: string;
  name?: string;
  explorer?: FilteredBlockchainExplorer;
};
export type FilteredBlockchainWallet = {
  address?: string;
  blockchain?: FilteredBlockchainNetwork;
};
export type FilteredBlockchainBeneficiary = {
  legalEntity?: FilteredLegalEntity;
  nickname?: string;
  resourceType?: string;
  wallet?: FilteredBlockchainWallet;
};
export type FilteredBlockchainWithdrawalFee = {
  amount?: number;
  product?: string;
};
export type FilteredResolvedBlockchainWithdrawal = {
  beneficiary?: FilteredBlockchainBeneficiary | string;
  withdrawalState?: PaymentWithdrawalState;
  meta?: ResourceMetadata;
  reference?: string;
  valueDate?: string;
  fee?: FilteredBlockchainWithdrawalFee;
  instructionState?: InstructionState;
};
export type FilteredResolvedBlockchainWithdrawalRead = {
  beneficiary?: FilteredBlockchainBeneficiary | string;
  withdrawalState?: PaymentWithdrawalState;
  meta?: ResourceMetadataRead;
  reference?: string;
  valueDate?: string;
  fee?: FilteredBlockchainWithdrawalFee;
  instructionState?: InstructionState;
};
export type FilteredResolvedBlockchainTransactionNetworkFeeWallet = {
  address: string;
  blockchain?: FilteredBlockchainNetwork;
};
export type FilteredResolvedBlockchainTransactionNetworkFee = {
  wallet: FilteredResolvedBlockchainTransactionNetworkFeeWallet;
};
export type FilteredResolvedBlockchainTransactionTransfer = {
  creditWallet?: {
    address?: string;
  };
  debitWallet?: {
    address?: string;
  };
};
export type FilteredResolvedBlockchainTransaction = {
  transactionState?: BankTransactionState;
  transactionTime?: string;
  txHash?: string;
  reference?: string;
  valueDate?: string;
  meta?: ResourceMetadata;
  blockchain?: FilteredBlockchainNetwork;
  networkFee?: FilteredResolvedBlockchainTransactionNetworkFee;
  transfers?: FilteredResolvedBlockchainTransactionTransfer[];
};
export type FilteredResolvedBlockchainTransactionRead = {
  transactionState?: BankTransactionState;
  transactionTime?: string;
  txHash?: string;
  reference?: string;
  valueDate?: string;
  meta?: ResourceMetadataRead;
  blockchain?: FilteredBlockchainNetwork;
  networkFee?: FilteredResolvedBlockchainTransactionNetworkFee;
  transfers?: FilteredResolvedBlockchainTransactionTransfer[];
};
export type TradeFiltered = {
  /** Counter amount */
  counterAmount?: number;
  /** Base amount */
  baseAmount?: number;
  /** Base currency code */
  baseCurrency?: string;
  /** Counter currency code */
  counterCurrency?: string;
  /** Whether the trade is settled */
  settled?: boolean;
  /** Value date */
  valueDate?: string;
  meta?: ResourceMetadata;
  /** Trade reference */
  reference?: string;
};
export type TradeFilteredRead = {
  /** Counter amount */
  counterAmount?: number;
  /** Base amount */
  baseAmount?: number;
  /** Base currency code */
  baseCurrency?: string;
  /** Counter currency code */
  counterCurrency?: string;
  /** Whether the trade is settled */
  settled?: boolean;
  /** Value date */
  valueDate?: string;
  meta?: ResourceMetadataRead;
  /** Trade reference */
  reference?: string;
};
export type FilteredPosting = {
  valueDate?: string;
  meta?: ResourceMetadata;
  reference?: string;
  amount?: number;
  currency?: string;
  comment?: string;
};
export type FilteredPostingRead = {
  valueDate?: string;
  meta?: ResourceMetadataRead;
  reference?: string;
  amount?: number;
  currency?: string;
  comment?: string;
};
export type LedgerEntryResolved = LedgerEntry & {
  /** Resolved journal data based on journal type. The shape depends on the entry's journal field. */
  resolvedData?:
    | null
    | FilteredResolvedPaymentData
    | FilteredResolvedBankTransaction
    | FilteredResolvedBlockchainWithdrawal
    | FilteredResolvedBlockchainTransaction
    | TradeFiltered
    | FilteredPosting;
};
export type LedgerEntryResolvedRead = LedgerEntry & {
  /** Resolved journal data based on journal type. The shape depends on the entry's journal field. */
  resolvedData?:
    | null
    | FilteredResolvedPaymentDataRead
    | FilteredResolvedBankTransactionRead
    | FilteredResolvedBlockchainWithdrawalRead
    | FilteredResolvedBlockchainTransactionRead
    | TradeFilteredRead
    | FilteredPostingRead;
};
export type ResolvedStatement = {
  /** Code of a `ledger-account` entity managed by the `@jftechnology/ledger` service.
   */
  ledgerCode: number;
  /** Id of a product entity managed by the `@jftechnology/ledger` service
   */
  product: string;
  /** The resource type of the product as defined in its respective `Product.resourceType` property. */
  productType: string;
  startDate: string;
  endDate: string;
  openingBalance: number;
  closingBalance: number;
  /** The id of a booking entity */
  bookingEntity?: string;
  /** UUID of a bank account entity managed by the `@jftechnology/journal-payment` service. */
  bankAccount?: string;
  /** The system wide UUID of a customer account. */
  customerAccount?: string;
  /** The system wide UUID of a customer subaccount. */
  customerSubaccount?: string;
  entries?: LedgerEntryResolved[];
};
export type ResolvedStatementRead = {
  /** Code of a `ledger-account` entity managed by the `@jftechnology/ledger` service.
   */
  ledgerCode: number;
  /** Id of a product entity managed by the `@jftechnology/ledger` service
   */
  product: string;
  /** The resource type of the product as defined in its respective `Product.resourceType` property. */
  productType: string;
  startDate: string;
  endDate: string;
  openingBalance: number;
  closingBalance: number;
  /** The id of a booking entity */
  bookingEntity?: string;
  /** UUID of a bank account entity managed by the `@jftechnology/journal-payment` service. */
  bankAccount?: string;
  /** The system wide UUID of a customer account. */
  customerAccount?: string;
  /** The system wide UUID of a customer subaccount. */
  customerSubaccount?: string;
  entries?: LedgerEntryResolvedRead[];
};
export type ResolvedLedgerEntryPage = {
  data: LedgerEntryResolved[];
  meta?: PageMetadata;
};
export type ResolvedLedgerEntryPageRead = {
  data: LedgerEntryResolvedRead[];
  meta?: PageMetadata;
};
export type CreateOtopRequest = {
  /** Optional content body of the required SMS message */
  messageFormat?: string;
};
export type OtopRequestResponse = {
  /** Unique id for the OTOP request */
  id: string;
  state: OtopRequestState;
  /** Number of failed verification attempts */
  failures: number;
  /** Time indicating when OTOP will expire */
  expiryTime: string;
};
export type VerifyOtopRequest = {
  /** 4 digit OTOP sent to a recipient. */
  otop: string;
};
export type CopCheckResponse = {
  status: CopMatchResult;
  /** Human-readable description of the status */
  statusDescription?: string;
  /** Name of the account holder as registered with the bank */
  bankAccountHolderName?: string;
  /** Name of the bank */
  bankName?: string;
  /** Registration ID from the provider */
  providerRegistrationId?: string;
  /** The name that was matched (typically used for CLOSE_MATCH status) */
  matchedName?: string;
};
export type CopCheckRequest = {
  beneficiaryType: LegalEntityType;
  /** ISO 4217 currency code */
  currency: string;
  /** ISO 3166-1 alpha-2 country code */
  country: string;
  /** Name of the account holder to verify */
  accountName: string;
  /** Bank account number */
  accountNumber?: string;
  /** National clearing code (e.g., sort code in UK) */
  nationalClearingCode?: string;
  /** International Bank Account Number */
  iban?: string;
};
export type Confirmer = {
  /** Unique identifier of the person who can confirm */
  id: string;
  /** First name of the confirmer */
  firstName: string;
  /** Last name of the confirmer */
  lastName: string;
};
export type ConfirmationRequirement = {
  /** Unique identifier for the resource */
  id: string;
  /** Type of resource requiring confirmation */
  resourceType: string;
  /** Whether Strong Customer Authentication is required */
  scaRequired: boolean;
  /** Number of confirmers required */
  confirmersRequired: number;
  /** Array of confirmer objects for users who have already confirmed */
  currentConfirmers: Confirmer[];
  /** Array of confirmer objects for users who are available to confirm */
  availableConfirmers: Confirmer[];
};
export type ConfirmInstructionRequest = {
  /** Whether to confirm or reject the instruction */
  confirmed: boolean;
};
export type PaymentStripped = {
  id: string;
  resourceType: string;
  reference: string;
  meta: ResourceMetadata;
  /** Unique key of this transaction in the downstream source */
  correlationId?: string;
  paymentState: PaymentWithdrawalState;
  /** Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
   */
  currency: string;
  amount: number;
  /** UUID of the beneficiary */
  beneficiary: string;
  /** The system wide UUID of a customer account. */
  customerAccount: string;
  customerReference?: string;
  paymentDate: string;
  valueDate?: string;
  acceptableUntil?: string;
  chargeCode?: ChargeBearer;
  operationCode?: OperationCode;
  remittanceInformation?: string;
  paymentReason?: string;
  purposeCode?: string;
  ultimateBeneficiary?: string;
  /** Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
   */
  feeCurrency?: string;
  feeAmount?: number;
  instructionState: InstructionState;
  /** The system wide UUID of a person. */
  instructionOriginator?: string;
  /** The system wide UUID of a person. */
  instructionPlacer?: string;
  instructionConfirmers?: string[];
  scaMethod?: ScaMethod;
  processingState?: ProcessingState;
  /** Correlation UUID for the processing operation */
  processingId?: string;
  processedBankTransaction?: string;
  comment?: string;
};
export type PaymentStrippedRead = {
  id: string;
  resourceType: string;
  reference: string;
  meta: ResourceMetadataRead;
  /** Unique key of this transaction in the downstream source */
  correlationId?: string;
  paymentState: PaymentWithdrawalState;
  /** Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
   */
  currency: string;
  amount: number;
  /** UUID of the beneficiary */
  beneficiary: string;
  /** The system wide UUID of a customer account. */
  customerAccount: string;
  customerReference?: string;
  paymentDate: string;
  valueDate?: string;
  acceptableUntil?: string;
  chargeCode?: ChargeBearer;
  operationCode?: OperationCode;
  remittanceInformation?: string;
  paymentReason?: string;
  purposeCode?: string;
  ultimateBeneficiary?: string;
  /** Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
   */
  feeCurrency?: string;
  feeAmount?: number;
  instructionState: InstructionState;
  /** The system wide UUID of a person. */
  instructionOriginator?: string;
  /** The system wide UUID of a person. */
  instructionPlacer?: string;
  instructionConfirmers?: string[];
  scaMethod?: ScaMethod;
  processingState?: ProcessingState;
  /** Correlation UUID for the processing operation */
  processingId?: string;
  processedBankTransaction?: string;
  comment?: string;
};
export type PaymentStrippedPage = {
  data: PaymentStripped[];
  meta?: PageMetadata;
};
export type PaymentStrippedPageRead = {
  data: PaymentStrippedRead[];
  meta?: PageMetadata;
};
export type ConfirmWithdrawalInstructionRequest = {
  /** Whether to confirm or reject the withdrawal instruction */
  confirmed: boolean;
};
export type BlockchainWithdrawalStripped = {
  /** Journal UUID of a blockchain withdrawal */
  id: string;
  resourceType: string;
  reference: string;
  meta: ResourceMetadata;
  withdrawalState: PaymentWithdrawalState;
  /** UUID of a withdrawal beneficiary entity */
  beneficiary: string;
  amount: number;
  customerReference?: string;
  withdrawalDate: string;
  valueDate?: string;
  acceptableUntil?: string;
  fee?: {
    product?: string;
    amount?: number;
  };
  instructionState: InstructionState;
  /** The system wide UUID of a person. */
  instructionOriginator?: string;
  /** The system wide UUID of a person. */
  instructionPlacer?: string;
  instructionConfirmers?: string[];
  scaMethod?: ScaMethod;
  processingId?: string;
  comment?: string;
};
export type BlockchainWithdrawalStrippedRead = {
  /** Journal UUID of a blockchain withdrawal */
  id: string;
  resourceType: string;
  reference: string;
  meta: ResourceMetadataRead;
  withdrawalState: PaymentWithdrawalState;
  /** UUID of a withdrawal beneficiary entity */
  beneficiary: string;
  amount: number;
  customerReference?: string;
  withdrawalDate: string;
  valueDate?: string;
  acceptableUntil?: string;
  fee?: {
    product?: string;
    amount?: number;
  };
  instructionState: InstructionState;
  /** The system wide UUID of a person. */
  instructionOriginator?: string;
  /** The system wide UUID of a person. */
  instructionPlacer?: string;
  instructionConfirmers?: string[];
  scaMethod?: ScaMethod;
  processingId?: string;
  comment?: string;
};
export type PaymentReason = {
  /** Unique identifier (will be backend-provided ID in future) */
  id: string;
  /** Translation key for frontend i18n lookup */
  name: string;
  /** Human-readable fallback if translation unavailable */
  description: string;
};
export type FilteredTickerPrice = {
  /** Bid price */
  bid: number;
  /** Ask price */
  ask: number;
  /** Base product symbol */
  baseProduct: string;
  /** Counter product symbol */
  counterProduct: string;
};
export type FilteredTickerPricePage = {
  data: FilteredTickerPrice[];
};
export type IdOnlyResponse = {
  id: string;
};
export type AccountBankAccount = {
  /** Account name */
  accountName: string;
  accountType?: BeneficiarySource;
  accountNameConfirmation?: CopStatus;
  /** Account number */
  accountNumber?: string;
  /** National clearing code */
  nationalClearingCode?: string;
  /** National clearing code type */
  nationalClearingCodeType?: string;
  /** National bank code */
  nationalBankCode?: string;
  /** National branch code */
  nationalBranchCode?: string;
  /** IBAN */
  iban?: string;
  /** BIC code */
  bic?: string;
  /** Country code */
  country: string;
  /** Nickname */
  nickname?: string;
  /** Beneficial owners */
  beneficialOwners?: {
    id: string;
    resourceType: string;
  }[];
  meta?: ResourceMetadata;
};
export type AccountBankAccountRead = {
  /** UUID of the bank account */
  id?: string;
  /** Resource type */
  resourceType?: string;
  /** Account name */
  accountName: string;
  accountType?: BeneficiarySource;
  accountNameConfirmation?: CopStatus;
  /** Account number */
  accountNumber?: string;
  /** National clearing code */
  nationalClearingCode?: string;
  /** National clearing code type */
  nationalClearingCodeType?: string;
  /** National bank code */
  nationalBankCode?: string;
  /** National branch code */
  nationalBranchCode?: string;
  /** IBAN */
  iban?: string;
  /** BIC code */
  bic?: string;
  /** Country code */
  country: string;
  /** Nickname */
  nickname?: string;
  /** Beneficial owners */
  beneficialOwners?: {
    id: string;
    resourceType: string;
  }[];
  meta?: ResourceMetadataRead;
};
export type AccountBeneficiaryAddress = {
  /** First name (required for PERSON type) */
  firstName?: string;
  /** Last name (required for PERSON type) */
  lastName?: string;
  /** Corporation name (required for CORPORATION type) */
  corporationName?: string;
  /** Address line 1 */
  line1?: string;
  /** Address line 2 */
  line2?: string;
  /** Address line 3 */
  line3?: string;
  /** Post town */
  postTown?: string;
  /** Post code */
  postCode?: string;
  /** State */
  state?: string;
  /** Country code */
  country?: string;
};
export type AccountBeneficiaryDefaults = {
  chargeCode?: ChargeBearer;
  operationCode?: OperationCode;
  /** Default intermediary */
  intermediary?: string;
  /** Default remittance information */
  remittanceInformation?: string;
  /** Default customer subaccount */
  customerSubaccount?: string;
  /** Default purpose code */
  purposeCode?: string;
};
export type AccountBeneficiaryVerification = {
  nameConfirmation?: CopStatus;
  /** Timestamp of last verification check */
  lastChecked?: string;
  /** Verification comment */
  comment?: string;
};
export type CreateBeneficiaryRequest = {
  /** The system wide UUID of a customer account. */
  customerAccount: string;
  bankAccount: AccountBankAccount;
  /** Currency code */
  currency: string;
  beneficiaryType: LegalEntityType;
  /** Customer reference */
  customerReference?: string;
  /** Beneficiary name */
  name?: string;
  /** Nickname */
  nickname?: string;
  address?: AccountBeneficiaryAddress;
  defaults?: AccountBeneficiaryDefaults;
  /** Whether this beneficiary is active */
  active?: boolean;
  /** Comment */
  comment?: string;
  verification?: AccountBeneficiaryVerification;
};
export type CreateBeneficiaryRequestRead = {
  /** The system wide UUID of a customer account. */
  customerAccount: string;
  bankAccount: AccountBankAccountRead;
  /** Currency code */
  currency: string;
  beneficiaryType: LegalEntityType;
  /** Customer reference */
  customerReference?: string;
  /** Beneficiary name */
  name?: string;
  /** Nickname */
  nickname?: string;
  address?: AccountBeneficiaryAddress;
  defaults?: AccountBeneficiaryDefaults;
  /** Whether this beneficiary is active */
  active?: boolean;
  /** Comment */
  comment?: string;
  verification?: AccountBeneficiaryVerification;
};
export type FilteredBankAccount = {
  /** Country code */
  country?: string;
  /** Account name */
  accountName?: string;
  /** Account number */
  accountNumber?: string;
  /** National clearing code */
  nationalClearingCode?: string;
  /** IBAN */
  iban?: string;
  /** BIC code */
  bic?: string;
};
export type FilteredBeneficiaryAddress = {
  /** First name */
  firstName?: string;
  /** Last name */
  lastName?: string;
  /** Corporation name */
  corporationName?: string;
  /** Address line 1 */
  line1?: string;
  /** Address line 2 */
  line2?: string;
  /** Post town */
  postTown?: string;
  /** Post code */
  postCode?: string;
  /** State */
  state?: string;
  /** Country code */
  country?: string;
};
export type FilteredBeneficiaryDefaults = {
  /** Default remittance information */
  remittanceInformation?: string;
  /** Default purpose code */
  purposeCode?: string;
  operationCode?: OperationCode;
  chargeCode?: ChargeBearer;
};
export type FilteredBeneficiaryVerification = {
  nameConfirmation?: CopStatus;
};
export type FilteredBeneficiaryDetail = {
  /** UUID of the beneficiary */
  id: string;
  /** Resource type */
  resourceType?: string;
  /** Nickname */
  nickname?: string;
  /** Currency code */
  currency: string;
  beneficiaryType: LegalEntityType;
  /** Whether this beneficiary is trusted */
  trusted?: boolean;
  bankAccount?: FilteredBankAccount;
  address?: FilteredBeneficiaryAddress;
  defaults?: FilteredBeneficiaryDefaults;
  verification?: FilteredBeneficiaryVerification;
};
export type UpdateBeneficiaryRequest = {
  beneficiaryType: LegalEntityType;
  /** Customer reference */
  customerReference?: string;
  /** Beneficiary name */
  name?: string;
  /** Nickname */
  nickname?: string;
  address?: AccountBeneficiaryAddress;
  defaults?: AccountBeneficiaryDefaults;
  /** Whether this beneficiary is active */
  active?: boolean;
  /** Comment */
  comment?: string;
};
export type PricingEngineRequestBase = {
  /** Pricing request UUID */
  id: string;
  /** Resource type */
  resourceType?: string;
  state: PricingQuoteState;
  indicativeStateReason?: PricingAlert;
  /** Time to live */
  timeToLive?: number;
  meta?: ResourceMetadata;
  /** The system wide UUID of a customer account. */
  customerAccount: string;
  /** The system wide UUID of a customer subaccount. */
  customerSubaccount?: string;
  /** The system wide UUID of a person. */
  originator: string;
  /** The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC), */
  silo: string;
  /** Booking entity code */
  bookingEntity?: string;
  /** Comment */
  comment?: string;
};
export type PricingEngineRequestBaseRead = {
  /** Pricing request UUID */
  id: string;
  /** Resource type */
  resourceType?: string;
  state: PricingQuoteState;
  indicativeStateReason?: PricingAlert;
  /** Time to live */
  timeToLive?: number;
  meta?: ResourceMetadataRead;
  /** The system wide UUID of a customer account. */
  customerAccount: string;
  /** The system wide UUID of a customer subaccount. */
  customerSubaccount?: string;
  /** The system wide UUID of a person. */
  originator: string;
  /** The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC), */
  silo: string;
  /** Booking entity code */
  bookingEntity?: string;
  /** Comment */
  comment?: string;
};
export type ResolvedPayment = {
  id?: string;
  resourceType?: string;
  reference?: string;
  paymentState?: PaymentWithdrawalState;
  currency?: string;
  amount?: number;
  /** Resolved beneficiary object (full object instead of UUID) */
  beneficiary?: {
    id?: string;
    resourceType?: string;
    name?: string;
    nickname?: string;
    customerReference?: string;
    currency?: string;
    beneficiaryType?: LegalEntityType;
    bankAccount?: AccountBankAccount;
    trusted?: boolean;
    active?: boolean;
  };
  customerAccount?: string;
  silo?: string;
  bookingEntity?: string;
  paymentDate?: string;
  valueDate?: string;
  instructionState?: InstructionState;
  operationCode?: OperationCode;
  scaMethod?: ScaMethod;
  riskAssessmentState?: ComplianceCheckState;
  processingState?: ProcessingState;
  feeCurrency?: string;
  feeAmount?: number;
  remittanceInformation?: string;
  paymentReason?: string;
  purposeCode?: string;
  meta?: ResourceMetadata;
};
export type ResolvedPaymentRead = {
  id?: string;
  resourceType?: string;
  reference?: string;
  paymentState?: PaymentWithdrawalState;
  currency?: string;
  amount?: number;
  /** Resolved beneficiary object (full object instead of UUID) */
  beneficiary?: {
    id?: string;
    resourceType?: string;
    name?: string;
    nickname?: string;
    customerReference?: string;
    currency?: string;
    beneficiaryType?: LegalEntityType;
    bankAccount?: AccountBankAccountRead;
    trusted?: boolean;
    active?: boolean;
  };
  customerAccount?: string;
  silo?: string;
  bookingEntity?: string;
  paymentDate?: string;
  valueDate?: string;
  instructionState?: InstructionState;
  operationCode?: OperationCode;
  scaMethod?: ScaMethod;
  riskAssessmentState?: ComplianceCheckState;
  processingState?: ProcessingState;
  feeCurrency?: string;
  feeAmount?: number;
  remittanceInformation?: string;
  paymentReason?: string;
  purposeCode?: string;
  meta?: ResourceMetadataRead;
};
export type ResolvedDeliveryInstruction = {
  /** Purpose code */
  purposeCode?: string;
  /** Beneficiary UUID */
  beneficiary?: string;
  operationCode?: OperationCode;
  chargeCode?: ChargeBearer;
  /** Payment reason */
  paymentReason?: string;
  /** Remittance information */
  remittanceInformation?: string;
  /** Fee amount */
  feeAmount?: number;
  /** Fee currency code */
  feeCurrency?: string;
  /** Payment correlation ID */
  paymentCorrelationId?: string;
  payment?: ResolvedPayment;
};
export type ResolvedDeliveryInstructionRead = {
  /** Purpose code */
  purposeCode?: string;
  /** Beneficiary UUID */
  beneficiary?: string;
  operationCode?: OperationCode;
  chargeCode?: ChargeBearer;
  /** Payment reason */
  paymentReason?: string;
  /** Remittance information */
  remittanceInformation?: string;
  /** Fee amount */
  feeAmount?: number;
  /** Fee currency code */
  feeCurrency?: string;
  /** Payment correlation ID */
  paymentCorrelationId?: string;
  payment?: ResolvedPaymentRead;
};
export type SwapInstructionBase = {
  /** Pay currency code */
  payCurrency?: string;
  /** Pay amount */
  payAmount?: number;
  /** Receive currency code */
  receiveCurrency?: string;
  /** Receive amount */
  receiveAmount?: number;
  quote?: QuoteAmountType;
  tenor?: TenorType;
  /** Comment */
  comment?: string;
  /** Value date */
  valueDate?: string;
  deliveryInstruction?: ResolvedDeliveryInstruction;
};
export type SwapInstructionBaseRead = {
  /** Pay currency code */
  payCurrency?: string;
  /** Pay amount */
  payAmount?: number;
  /** Receive currency code */
  receiveCurrency?: string;
  /** Receive amount */
  receiveAmount?: number;
  quote?: QuoteAmountType;
  tenor?: TenorType;
  /** Comment */
  comment?: string;
  /** Value date */
  valueDate?: string;
  deliveryInstruction?: ResolvedDeliveryInstructionRead;
};
export type FilteredSwapInstruction = SwapInstructionBase & {
  /** Pay fee */
  payFee?: number;
  /** Receive fee */
  receiveFee?: number;
  /** Instruction state */
  state?: string;
  /** Indicative state reason */
  indicativeStateReason?: string;
  /** Settlement time */
  settlementTime?: string;
  /** Resolved transaction object or transaction UUID string */
  transaction?:
    | {
        id?: string;
        resourceType?: string;
        state?: string;
      }
    | string;
};
export type FilteredSwapInstructionRead = SwapInstructionBaseRead & {
  /** Pay fee */
  payFee?: number;
  /** Receive fee */
  receiveFee?: number;
  /** Instruction state */
  state?: string;
  /** Indicative state reason */
  indicativeStateReason?: string;
  /** Settlement time */
  settlementTime?: string;
  /** Resolved transaction object or transaction UUID string */
  transaction?:
    | {
        id?: string;
        resourceType?: string;
        state?: string;
      }
    | string;
};
export type FilteredPricingEngineRequest = PricingEngineRequestBase & {
  /** Filtered swap instructions */
  instructions: FilteredSwapInstruction[];
};
export type FilteredPricingEngineRequestRead = PricingEngineRequestBaseRead & {
  /** Filtered swap instructions */
  instructions: FilteredSwapInstructionRead[];
};
export type PricingSwapInstruction = SwapInstructionBase & {
  /** Margin currency code */
  marginCurrency: string;
  /** Margin amount */
  marginAmount?: number;
  /** Transaction UUID */
  transaction?: string;
};
export type PricingSwapInstructionRead = SwapInstructionBaseRead & {
  /** Margin currency code */
  marginCurrency: string;
  /** Margin amount */
  marginAmount?: number;
  /** Transaction UUID */
  transaction?: string;
};
export type CreatePricingEngineRequest = {
  /** The system wide UUID of a customer account. */
  customerAccount: string;
  /** The system wide UUID of a customer subaccount. */
  customerSubaccount?: string;
  /** Deprecated and ignored. The BFF derives the originator from the authenticated user's token and never reads this field. The web still sends the signed-in user's id here so that a web release deployed ahead of this BFF keeps quoting against a BFF that still forwards the body's originator; the web stops sending it once this BFF is deployed. */
  originator?: string;
  /** Booking entity code */
  bookingEntity?: string;
  /** Comment */
  comment?: string;
  /** Swap instructions */
  instructions: PricingSwapInstruction[];
};
export type CreatePricingEngineRequestRead = {
  /** The system wide UUID of a customer account. */
  customerAccount: string;
  /** The system wide UUID of a customer subaccount. */
  customerSubaccount?: string;
  /** Deprecated and ignored. The BFF derives the originator from the authenticated user's token and never reads this field. The web still sends the signed-in user's id here so that a web release deployed ahead of this BFF keeps quoting against a BFF that still forwards the body's originator; the web stops sending it once this BFF is deployed. */
  originator?: string;
  /** Booking entity code */
  bookingEntity?: string;
  /** Comment */
  comment?: string;
  /** Swap instructions */
  instructions: PricingSwapInstructionRead[];
};
export type RequotePricingRequest = {
  /** Updated swap instructions. Each update replaces the stored instruction at the same position. In an update's deliveryInstruction, an omitted or null field keeps the stored value and a field sent as an empty string is left out of the instruction sent to the pricing engine; a changed beneficiary starts from an empty delivery instruction. Only beneficiary, operationCode, chargeCode, remittanceInformation, paymentReason and purposeCode are sent: feeAmount, feeCurrency, paymentCorrelationId, relatedPayment and payment are never read from the client and never echoed from the stored instruction, so the pricing engine prices each requote's fees afresh. Leaving a field out clears it only if the pricing engine replaces a requote's delivery instruction rather than merging it; replace semantics are the design basis. On 2026-10-05 the owner reported requotes working on uat with this merge; a cleared field and a re-priced fee were not tested directly. */
  updates: PricingSwapInstruction[];
};
export type RequotePricingRequestRead = {
  /** Updated swap instructions. Each update replaces the stored instruction at the same position. In an update's deliveryInstruction, an omitted or null field keeps the stored value and a field sent as an empty string is left out of the instruction sent to the pricing engine; a changed beneficiary starts from an empty delivery instruction. Only beneficiary, operationCode, chargeCode, remittanceInformation, paymentReason and purposeCode are sent: feeAmount, feeCurrency, paymentCorrelationId, relatedPayment and payment are never read from the client and never echoed from the stored instruction, so the pricing engine prices each requote's fees afresh. Leaving a field out clears it only if the pricing engine replaces a requote's delivery instruction rather than merging it; replace semantics are the design basis. On 2026-10-05 the owner reported requotes working on uat with this merge; a cleared field and a re-priced fee were not tested directly. */
  updates: PricingSwapInstructionRead[];
};
export type FilteredPaymentForList = {
  id: string;
  resourceType: string;
  reference: string;
  meta: ResourceMetadata;
  currency: string;
  amount: number;
  beneficiary: FilteredFiatBeneficiary;
  paymentDate: string;
  valueDate?: string;
  paymentState: PaymentWithdrawalState;
  instructionState: InstructionState;
  scaMethod?: ScaMethod;
  processingState?: ProcessingState;
  remittanceInformation?: string;
  /** Free-form reason/description for the payment (e.g., "Q3 invoice settlement"). */
  paymentReason?: string;
  /** Coded purpose classification (e.g., "goods_sold"). Translated via PaymentReason dictionary on the frontend. */
  purposeCode?: string;
  feeAmount?: number;
  feeCurrency?: string;
};
export type FilteredPaymentForListRead = {
  id: string;
  resourceType: string;
  reference: string;
  meta: ResourceMetadataRead;
  currency: string;
  amount: number;
  beneficiary: FilteredFiatBeneficiary;
  paymentDate: string;
  valueDate?: string;
  paymentState: PaymentWithdrawalState;
  instructionState: InstructionState;
  scaMethod?: ScaMethod;
  processingState?: ProcessingState;
  remittanceInformation?: string;
  /** Free-form reason/description for the payment (e.g., "Q3 invoice settlement"). */
  paymentReason?: string;
  /** Coded purpose classification (e.g., "goods_sold"). Translated via PaymentReason dictionary on the frontend. */
  purposeCode?: string;
  feeAmount?: number;
  feeCurrency?: string;
};
export type FilteredVirtualAssetForPayment = {
  ledgerProduct?: string;
};
export type FilteredBlockchainBeneficiaryForPayment = {
  legalEntity?: FilteredLegalEntity;
  nickname?: string;
  resourceType?: string;
  wallet?: FilteredBlockchainWallet;
  asset?: FilteredVirtualAssetForPayment;
};
export type FilteredBlockchainWithdrawalForList = {
  id: string;
  resourceType: string;
  reference: string;
  meta: ResourceMetadata;
  amount: number;
  beneficiary: FilteredBlockchainBeneficiaryForPayment;
  withdrawalDate: string;
  valueDate?: string;
  withdrawalState: PaymentWithdrawalState;
  instructionState: InstructionState;
  scaMethod?: ScaMethod;
  processingState?: ProcessingState;
  fee?: FilteredBlockchainWithdrawalFee;
};
export type FilteredBlockchainWithdrawalForListRead = {
  id: string;
  resourceType: string;
  reference: string;
  meta: ResourceMetadataRead;
  amount: number;
  beneficiary: FilteredBlockchainBeneficiaryForPayment;
  withdrawalDate: string;
  valueDate?: string;
  withdrawalState: PaymentWithdrawalState;
  instructionState: InstructionState;
  scaMethod?: ScaMethod;
  processingState?: ProcessingState;
  fee?: FilteredBlockchainWithdrawalFee;
};
export type BeneficiaryTemplateField = {
  attribute?: string;
  description?: string;
  label?: string;
  regex?: string;
  required?: boolean;
};
export type BeneficiaryTemplate = {
  id?: string;
  resourceType?: string;
  currency?: string;
  country?: string;
  beneficiaryType?: LegalEntityType;
  defaultOperationCode?: OperationCode;
  addressRequired?: Not_requiredOptionalRequired;
  name?: string;
  description?: string;
  fields?: BeneficiaryTemplateField[];
  paymentSystems?: string[];
  operationCodes?: string[];
};
export type BeneficiaryTemplatePage = {
  data?: BeneficiaryTemplate[];
};
export type FilteredVirtualAsset = {
  id?: string;
  ledgerProduct?: string;
  blockchain?: {
    id?: string;
  };
};
export type FilteredVirtualAssetPage = {
  data?: FilteredVirtualAsset[];
  meta?: PageMetadata;
};
export type FilteredVaspInfo = {
  id?: string;
  name?: string;
};
export type FilteredVaspInfoPage = {
  data?: FilteredVaspInfo[];
  meta?: PageMetadata;
};
export type FilteredResolvedBlockchainBeneficiaryLegalEntity = {
  type: LegalEntityType;
  /** ISO 3166-1 Alpha-2 country code */
  country: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  townName: string;
  countrySubDivision?: string;
  postCode?: string;
  addressLine?: string[];
};
export type FilteredResolvedBlockchainBeneficiary = {
  id?: string;
  resourceType?: string;
  nickname?: string;
  trusted?: boolean;
  whitelisted?: boolean;
  walletType?: WalletType;
  wallet?: FilteredBlockchainWallet;
  asset?: {
    ledgerProduct?: string;
  };
  vasp?: FilteredVaspInfo;
  legalEntity?: FilteredResolvedBlockchainBeneficiaryLegalEntity;
};
export type SendEmailOtpRequest = {
  email: string;
  captchaToken: string;
};
export type VerifyEmailOtpRequest = {
  email: string;
  code: string;
};
export type SendOtpResponse = {
  message?: string;
  expiresIn?: number;
};
export type MobilePhone = {
  /** National phone number (without international prefix) */
  number: string;
  /** ISO 3166-1 alpha-2 country code (e.g. GB) */
  country: string;
};
export type SendSmsOtpRequest = {
  mobilePhone: MobilePhone;
  emailVerificationToken?: string;
};
export type VerifyOtpResponse = {
  verificationToken?: string;
};
export type VerifySmsOtpRequest = {
  mobilePhone: MobilePhone;
  code: string;
};
export type RegisterResponse = {
  refreshToken?: string;
};
export type RegisterRequest = {
  firstName: string;
  lastName: string;
  email: string;
  mobilePhone: MobilePhone;
  password: string;
  /** OAuth2 client ID for token issuance */
  clientId: string;
  emailVerificationToken: string;
  phoneVerificationToken: string;
};
export type PhonePrefix = {
  /** ISO 3166-1 alpha-2 country code */
  country?: string;
  /** International dialling prefix with leading + */
  phonePrefix?: string;
};
export type Registration = {
  id: string;
  email: string;
  /** E.164 formatted phone number */
  mobilePhone: string;
  kycStatus?: RequiredCompletedVerifiedRejected;
};
export type RegistrationPage = {
  data?: Registration[];
};
export type KycAccessTokenResponse = {
  /** Short-lived SumSub WebSDK access token (~10 min TTL) */
  token: string;
  /** Whether the caller still needs identity verification. When false, the frontend should skip the SumSub widget. */
  requiresVerification: boolean;
};
export type PersonalDetails = {
  title?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  dateOfBirth: string;
  /** ISO 3166-1 Alpha-2 country code */
  countryOfBirth?: string;
  nationalities?: string[];
  address: Address;
  occupation?: string;
};
export type AccountPurposeSelection = {
  selected: AccountPurpose[];
  /** Freeform explanation, typically provided when OTHER is selected. */
  comment?: string;
};
export type AccountUseFormData = {
  baseCurrency: string;
  accountPurpose: AccountPurposeSelection;
  monthlyTurnover: number;
  requiresDigitalAssets?: boolean;
  flowOfFunds?: string;
};
export type SourceOfFundsSelection = {
  selected: SourceOfFunds[];
  /** Freeform explanation, typically provided when OTHER is selected. */
  comment?: string;
};
export type IncomingPayments = {
  sourceOfFunds?: SourceOfFundsSelection;
  fromThirdParties: boolean;
  expectedCreditsPerMonth: number;
  /** Largest single incoming transaction value in base currency */
  maxCreditValue: number;
  sourceCountries?: string[];
  sourceCurrencies?: string[];
};
export type OutgoingPayments = {
  expectedDebitsPerMonth: number;
  /** Largest single outgoing transaction value in base currency */
  maxDebitValue: number;
  toThirdParties: boolean;
  destinationCountries?: string[];
  destinationCurrencies?: string[];
};
export type Consents = {
  termsAccepted: boolean;
  privacyAccepted: boolean;
  marketingOptIn: boolean;
  /** Whether the applicant acknowledged that they approached the firm on their own initiative (reverse solicitation). Required for applicants not based/incorporated in GB; sent as false for GB-based applicants. */
  reverseSolicitationAcknowledged: boolean;
};
export type BusinessTypeSelection = {
  selected?: BusinessType;
  /** Freeform explanation, typically provided when selected is OTHER. */
  comment?: string;
};
export type UserRelationshipSelection = {
  selected: PrimaryContactRelationship;
  /** Freeform explanation, typically provided when selected is OTHER. */
  comment?: string;
};
export type PrimaryContactDetails = {
  title?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  dateOfBirth: string;
  /** ISO 3166-1 Alpha-2 country code */
  nationality: string;
  email?: string;
  mobilePhone?: MobilePhone;
  address?: {
    udprn?: number;
    /** Summary line for non-structured addresses */
    line1?: string;
    line2?: string;
    line3?: string;
    buildingName?: string;
    /** When a premise is split into individual units such as flats, apartments or business units */
    buildingName2?: string;
    /** Number to identify premise on a thoroughfare */
    buildingNumber?: string;
    /** Street name */
    thoroughfare?: string;
    /** Secondary street name */
    thoroughfare2?: string;
    locality?: string;
    locality2?: string;
    postBox?: string;
    postTown?: string;
    /** Postcode in country print format */
    postCode?: string;
    organisation?: string;
    /** Department within the organisation */
    department?: string;
    /** Used for addresses in federal countries (US, MX, CA, etc) */
    state?: string;
    /** ISO 3166-1 Alpha-2 country code */
    country?: string;
    longitude?: number;
    latitude?: number;
  };
};
export type PrimaryContact = {
  isApplicant?: boolean;
  relationship?: UserRelationshipSelection;
  contactDetails?: PrimaryContactDetails;
};
export type BusinessDetailsFormData = {
  businessType?: BusinessTypeSelection;
  companyName: string;
  companyNumber: string;
  countryOfIncorporation: string;
  industrySector?: string;
  companyWebsite?: string;
  /** Business description including products/services, operational model, geographic footprint. Third-party payment explanations appended with prefix keys [THIRD_PARTY_INCOMING] and [THIRD_PARTY_OUTGOING].
   */
  businessDescription?: string;
  /** Reported annual revenue in base currency — the last financial year's figure, or a forecast for newly incorporated companies.
   */
  annualRevenue?: number;
  addresses?: {
    [key: string]: {
      udprn?: number;
      /** Summary line for non-structured addresses */
      line1?: string;
      line2?: string;
      line3?: string;
      buildingName?: string;
      /** When a premise is split into individual units such as flats, apartments or business units */
      buildingName2?: string;
      /** Number to identify premise on a thoroughfare */
      buildingNumber?: string;
      /** Street name */
      thoroughfare?: string;
      /** Secondary street name */
      thoroughfare2?: string;
      locality?: string;
      locality2?: string;
      postBox?: string;
      postTown?: string;
      /** Postcode in country print format */
      postCode?: string;
      organisation?: string;
      /** Department within the organisation */
      department?: string;
      /** Used for addresses in federal countries (US, MX, CA, etc) */
      state?: string;
      /** ISO 3166-1 Alpha-2 country code */
      country?: string;
      longitude?: number;
      latitude?: number;
    };
  };
  primaryContact?: PrimaryContact;
};
export type ApplicationFormData = {
  personalDetails?: PersonalDetails;
  accountUse?: AccountUseFormData;
  incomingPayments?: IncomingPayments;
  outgoingPayments?: OutgoingPayments;
  consents?: Consents;
  businessDetails?: BusinessDetailsFormData;
};
export type CustomerAccountApplication = {
  id?: string;
  applicationType?: ApplicationType;
  applicationState?: ApplicationState;
  requiresDigitalAssets?: boolean;
  silo?: string;
  formData?: ApplicationFormData;
  createdAt?: string;
  updatedAt?: string;
};
export type CustomerAccountApplicationPage = {
  data?: CustomerAccountApplication[];
};
export type CreateCustomerAccountApplicationRequest = {
  applicationType: ApplicationType;
  requiresDigitalAssets?: boolean;
  silo?: string;
};
export type UpdateCustomerAccountApplicationRequest = {
  formData?: ApplicationFormData;
};
export type TransactionRanges = {
  currency?: string;
  /** Upper-bound values for monthly turnover (e.g., [100000, 250000, 500000, 1000000, 5000000]) */
  monthlyTurnoverOptions?: number[];
  /** Upper-bound values for single transaction (e.g., [10000, 50000, 100000, 250000, 500000]) */
  singleTransactionOptions?: number[];
  /** Upper-bound values for expected transaction count (e.g., [10, 50, 100, 500, 1000]) */
  creditsPerMonthOptions?: number[];
  /** Upper-bound values for expected debit count (e.g., [10, 50, 100, 500, 1000]) */
  debitsPerMonthOptions?: number[];
};
export type FilteredBusinessType = {
  id: string;
  name: string;
  sector: string;
};
export type FilteredBusinessTypePage = {
  data: FilteredBusinessType[];
};
export enum ActiveInactiveDeleted {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Deleted = "DELETED",
}
export enum ProductType {
  Currencies = "currencies",
  DigitalAssets = "digital-assets",
}
export enum OnlineTradingMode {
  TradingDeskOnly = "TRADING_DESK_ONLY",
}
export enum OnlineQuotationFlag {
  On = "ON",
  Off = "OFF",
  Suspended = "SUSPENDED",
}
export enum CountrySortBy {
  Id = "ID",
  Name = "NAME",
}
export enum AccountType {
  Personal = "PERSONAL",
  Corporate = "CORPORATE",
  SoleTrader = "SOLE_TRADER",
  LiquidityProvider = "LIQUIDITY_PROVIDER",
  Treasury = "TREASURY",
  Other = "OTHER",
}
export enum AccountState {
  Opening = "OPENING",
  Accepted = "ACCEPTED",
  Open = "OPEN",
  Suspended = "SUSPENDED",
  Closed = "CLOSED",
  Rejected = "REJECTED",
}
export enum AccountRole {
  Applicant = "APPLICANT",
  Owner = "OWNER",
  User = "USER",
  ViewOnly = "VIEW_ONLY",
  None = "NONE",
  Deleted = "DELETED",
}
export enum ComplianceCheckState {
  Pending = "PENDING",
  Passed = "PASSED",
  Failed = "FAILED",
  NotRequired = "NOT_REQUIRED",
}
export enum LegalEntityType {
  Person = "PERSON",
  Corporation = "CORPORATION",
}
export enum PaymentWithdrawalState {
  Scheduled = "SCHEDULED",
  Accepted = "ACCEPTED",
  FundsConfirmed = "FUNDS_CONFIRMED",
  Processing = "PROCESSING",
  Cancelled = "CANCELLED",
  Reconciled = "RECONCILED",
}
export enum InstructionState {
  Unconfirmed = "UNCONFIRMED",
  Confirmed = "CONFIRMED",
  Accepted = "ACCEPTED",
  Cancelled = "CANCELLED",
}
export enum BankTransactionState {
  Pending = "PENDING",
  Unreconciled = "UNRECONCILED",
  Reconciled = "RECONCILED",
  Rejected = "REJECTED",
  Returned = "RETURNED",
}
export enum TimeFrame {
  Book = "BOOK",
  Value = "VALUE",
}
export enum OtopRequestState {
  Pending = "PENDING",
  Completed = "COMPLETED",
  Failed = "FAILED",
  Expired = "EXPIRED",
  Exhausted = "EXHAUSTED",
}
export enum OtopRequestResourceType {
  Payments = "payments",
  BlockchainWithdrawals = "blockchain-withdrawals",
  Beneficiaries = "beneficiaries",
  BlockchainBeneficiaries = "blockchain-beneficiaries",
}
export enum CopMatchResult {
  Match = "MATCH",
  CloseMatch = "CLOSE_MATCH",
  NoMatch = "NO_MATCH",
  Unknown = "UNKNOWN",
  Unavailable = "UNAVAILABLE",
  NotSupported = "NOT_SUPPORTED",
}
export enum ChargeBearer {
  Ben = "BEN",
  Our = "OUR",
  Sha = "SHA",
}
export enum OperationCode {
  Spri = "SPRI",
  Sstd = "SSTD",
  Spay = "SPAY",
}
export enum ScaMethod {
  None = "NONE",
  TrustedBeneficiary = "TRUSTED_BENEFICIARY",
  TwoFactor = "TWO_FACTOR",
  ManualCheck = "MANUAL_CHECK",
  RecurringTransaction = "RECURRING_TRANSACTION",
  LowValue = "LOW_VALUE",
}
export enum ProcessingState {
  Waiting = "WAITING",
  Ready = "READY",
  Processing = "PROCESSING",
  Rejected = "REJECTED",
  Completed = "COMPLETED",
  Failed = "FAILED",
}
export enum BeneficiarySource {
  Beneficiary = "BENEFICIARY",
  Source = "SOURCE",
  Virtual = "VIRTUAL",
}
export enum CopStatus {
  Unknown = "UNKNOWN",
  Correct = "CORRECT",
  Incorrect = "INCORRECT",
}
export enum PricingQuoteState {
  Indicative = "INDICATIVE",
  Tradeable = "TRADEABLE",
  Accepted = "ACCEPTED",
  Booked = "BOOKED",
  Cancelled = "CANCELLED",
}
export enum PricingAlert {
  ExceedsCustomerFunds = "EXCEEDS_CUSTOMER_FUNDS",
  ExceedsOnlineTradingLimit = "EXCEEDS_ONLINE_TRADING_LIMIT",
  ExceedsTradingLimit = "EXCEEDS_TRADING_LIMIT",
  NoLivePrice = "NO_LIVE_PRICE",
  PaymentValuationAboveUpperBound = "PAYMENT_VALUATION_ABOVE_UPPER_BOUND",
  PaymentValuationBelowLowerBound = "PAYMENT_VALUATION_BELOW_LOWER_BOUND",
  ValueDateTooLate = "VALUE_DATE_TOO_LATE",
  OnlineQuotationSuspended = "ONLINE_QUOTATION_SUSPENDED",
  OnlineQuotationOff = "ONLINE_QUOTATION_OFF",
  OnlineQuotationClosed = "ONLINE_QUOTATION_CLOSED",
}
export enum QuoteAmountType {
  PayAmount = "PAY_AMOUNT",
  ReceiveAmount = "RECEIVE_AMOUNT",
  Cost = "COST",
}
export enum TenorType {
  Instant = "INSTANT",
  Next = "NEXT",
  Tod = "TOD",
  Tom = "TOM",
  Spot = "SPOT",
  Other = "OTHER",
}
export enum Not_requiredOptionalRequired {
  NotRequired = "NOT_REQUIRED",
  Optional = "OPTIONAL",
  Required = "REQUIRED",
}
export enum WalletType {
  Unknown = "UNKNOWN",
  Vasp = "VASP",
  SelfHosted = "SELF_HOSTED",
  SelfHostedThirdParty = "SELF_HOSTED_THIRD_PARTY",
}
export enum RequiredCompletedVerifiedRejected {
  Required = "REQUIRED",
  Completed = "COMPLETED",
  Verified = "VERIFIED",
  Rejected = "REJECTED",
}
export enum ApplicationType {
  Personal = "PERSONAL",
  Corporate = "CORPORATE",
}
export enum ApplicationState {
  Draft = "DRAFT",
  Submitted = "SUBMITTED",
  Admitted = "ADMITTED",
  Accepted = "ACCEPTED",
  Opened = "OPENED",
  Rejected = "REJECTED",
}
export enum AccountPurpose {
  Payments = "PAYMENTS",
  Trading = "TRADING",
  Savings = "SAVINGS",
  Payroll = "PAYROLL",
  BusinessExpenses = "BUSINESS_EXPENSES",
  Other = "OTHER",
}
export enum SourceOfFunds {
  Salary = "SALARY",
  BusinessRevenue = "BUSINESS_REVENUE",
  Investments = "INVESTMENTS",
  Savings = "SAVINGS",
  Pension = "PENSION",
  Inheritance = "INHERITANCE",
  Gift = "GIFT",
  Other = "OTHER",
}
export enum BusinessType {
  SoleTrader = "SOLE_TRADER",
  LimitedCompany = "LIMITED_COMPANY",
  Partnership = "PARTNERSHIP",
  Llp = "LLP",
  Plc = "PLC",
  Charity = "CHARITY",
  Other = "OTHER",
}
export enum PrimaryContactRelationship {
  PersonalAccountHolder = "PERSONAL_ACCOUNT_HOLDER",
  CorporateOfficer = "CORPORATE_OFFICER",
  CorporateEmployee = "CORPORATE_EMPLOYEE",
  Other = "OTHER",
}
export const {
  useGetSettlementMethodsQuery,
  useLazyGetSettlementMethodsQuery,
  useGetCustomerAccountBalancesQuery,
  useLazyGetCustomerAccountBalancesQuery,
  useGetCustomerAccountCapabilitiesQuery,
  useLazyGetCustomerAccountCapabilitiesQuery,
  useGetDeliverableCountriesQuery,
  useLazyGetDeliverableCountriesQuery,
  useGetCustomerAccountBeneficialOwnersQuery,
  useLazyGetCustomerAccountBeneficialOwnersQuery,
  useGetCountriesQuery,
  useLazyGetCountriesQuery,
  useGetSelfQuery,
  useLazyGetSelfQuery,
  useGetProductsQuery,
  useLazyGetProductsQuery,
  useGetCustomerAccountStatementQuery,
  useLazyGetCustomerAccountStatementQuery,
  useGetLedgerEntriesQuery,
  useLazyGetLedgerEntriesQuery,
  useCreateOtopMutation,
  useVerifyOtopMutation,
  useDoCopCheckMutation,
  useGetPaymentRequirementsQuery,
  useLazyGetPaymentRequirementsQuery,
  useGetBlockchainWithdrawalRequirementsQuery,
  useLazyGetBlockchainWithdrawalRequirementsQuery,
  useConfirmPaymentInstructionMutation,
  useCancelPaymentInstructionMutation,
  useConfirmBlockchainWithdrawalInstructionMutation,
  useCancelBlockchainWithdrawalInstructionMutation,
  useGetPaymentReasonsQuery,
  useLazyGetPaymentReasonsQuery,
  useGetPricesQuery,
  useLazyGetPricesQuery,
  useCreateBeneficiaryMutation,
  useGetBeneficiaryQuery,
  useLazyGetBeneficiaryQuery,
  useUpdateBeneficiaryMutation,
  useDeleteBeneficiaryMutation,
  useCreatePricingRequestMutation,
  useGetPricingRequestQuery,
  useLazyGetPricingRequestQuery,
  useRequotePricingRequestMutation,
  useAcceptPricingRequestMutation,
  useGetAllBeneficiariesQuery,
  useLazyGetAllBeneficiariesQuery,
  useGetUnconfirmedPaymentsQuery,
  useLazyGetUnconfirmedPaymentsQuery,
  useGetProcessingPaymentsQuery,
  useLazyGetProcessingPaymentsQuery,
  useGetBeneficiaryTemplatesQuery,
  useLazyGetBeneficiaryTemplatesQuery,
  useGetVirtualAssetsQuery,
  useLazyGetVirtualAssetsQuery,
  useGetVaspsQuery,
  useLazyGetVaspsQuery,
  useCreateBlockchainBeneficiaryMutation,
  useGetBlockchainBeneficiaryQuery,
  useLazyGetBlockchainBeneficiaryQuery,
  useUpdateBlockchainBeneficiaryMutation,
  useDeleteBlockchainBeneficiaryMutation,
  useSendRegistrationEmailOtpMutation,
  useVerifyRegistrationEmailOtpMutation,
  useSendRegistrationSmsOtpMutation,
  useVerifyRegistrationSmsOtpMutation,
  useRegisterMutation,
  useGetPhonePrefixesQuery,
  useLazyGetPhonePrefixesQuery,
  useGetRegistrationsQuery,
  useLazyGetRegistrationsQuery,
  useCreateKycAccessTokenMutation,
  useGetCustomerAccountApplicationsQuery,
  useLazyGetCustomerAccountApplicationsQuery,
  useCreateCustomerAccountApplicationMutation,
  useGetCustomerAccountApplicationQuery,
  useLazyGetCustomerAccountApplicationQuery,
  useUpdateCustomerAccountApplicationMutation,
  useSubmitCustomerAccountApplicationMutation,
  useGetTransactionRangesQuery,
  useLazyGetTransactionRangesQuery,
  useGetBusinessTypesQuery,
  useLazyGetBusinessTypesQuery,
} = injectedRtkApi;
